if (typeof UseSwStat == 'undefined' || typeof UseSwStat == 'null') {
    var UseSwStat = false;
}

if (typeof UseTagManager == 'undefined' || typeof UseTagManager == 'null') {
    UseTagManager = false;
}

function setContentHeight() {
    var sepetRowElements = document.getElementsByClassName('SepetRow');
    var basketCount = sepetRowElements.length;

    if ($(window).width() < 768) {
        var ContentHeight = 100 + (basketCount * 60);
        $(".BasketCenterContent").height(ContentHeight);
        $(".BasketCenterContent").css("max-height", "50vh");
    } else {
        var ContentHeight2 = 100 + (basketCount * 55);
        $(".BasketCenterContent").height(ContentHeight2);
        $(".BasketCenterContent").css("max-height", "45vh");
    }

    $(window).resize(function () {
        if ($(window).width() < 768) {
            var ContentHeight3 = 100 + (basketCount * 60);
            $(".BasketCenterContent").height(ContentHeight3);
            $(".BasketCenterContent").css("max-height", "50vh");
        } else {
            var ContentHeight4 = 100 + (basketCount * 55);
            $(".BasketCenterContent").height(ContentHeight4);
            $(".BasketCenterContent").css("max-height", "45vh");
        }
    });
}

function ClearCloudflareWidgets() {
    if (typeof turnstile !== 'undefined') {
        $('.cf-turnstile').each(function () {
            turnstile.reset(this);
        });
        console.log('Tüm Cloudflare widgetları temizlendi.');
    } else {
        console.log('Turnstile yüklenmemiş.');
    }
}

function DataLayerLoginSignUp(Type, UserID, AllowMail, AllowSms) {
    window.dataLayer = window.dataLayer || [];

    var event = "";

    if (Type == "login") {
        event = "login"
    }
    if (Type == "signup") {
        event = "sign_up"
    }

    const dataLayerObject = {
        'event': event,
        'email_permission': AllowMail,
        'sms_permission': AllowSms,
        'userId': UserID,
    };
    //  alert(JSON.stringify(dataLayerObject));

    if (window.dataLayer) {
        try {
            window.dataLayer.push(dataLayerObject);
        } catch (e) {

        }
    }
}

function toggleBasket() {

    if ($(".SepetProducts").is(":visible")) {
        $(".SepetProducts").stop().animate({ "left": "100%" }, 200, function () {
            $(".SepetProducts").stop().hide();
            $("body").removeClass("BasketDropped");
            $("body").removeClass("BackDropped");
        });
    }
    else {
        //$(".SepetProducts").stop().animate({ "left": "83%" }, 200, function () {
        $(".SepetProducts").stop().animate({ "right": "0%" }, 200, function () {
            $(".SepetProducts").stop().show();
            setContentHeight();
            $("body").addClass("BasketDropped");
        });
    }
}

function TagAutoComplate() {

    if ($("#SmallLangCode").val() != 'en') {

        $(".customAutoComplete").autocomplete({

            source: "/" + $("#SmallLangCode").val() + "/p/Cat/CompleteNames",
            minLength: 2,
            maxResults: 10,
            select: function (event, ui) {


                if (ui.item.FilterType == "Product") {
                    window.location.href = "/" + $("#SmallLangCode").val() + "/" + ui.item.HexValue;
                }

                if (ui.item.FilterType == "Tag" || ui.item.FilterType == "Color") {
                    window.location.href = "/" + $("#SmallLangCode").val() + "/p/Cat/NewSearch?sr=" + ui.item.MainValue;
                }


                //if (ui.item.FilterType == "BlogPost") {
                //    window.location.href = "/blog" + ui.item.SubValue;
                //}

                //$(".SearchModal input:first").val(ui.item.value);
                //$(".SearchModal form").submit();
            }
            ,
            create: function () {



                $(this).data('ui-autocomplete')._renderItem = function (ul, item) {


                    if (item.FilterType == "Product") {
                        $li = $('<li class="PrItem">').append('<img src="' + item.ImagePath + '" alt="" />');

                        $li.append("<span class='PrHeader'>" + item.SubValue + "</span>");
                        $li.append("<span>" + item.MainValue + "</span>");
                        $li.append("<span class='Info'></span>");

                        $li.appendTo(ul);

                        return $li;

                    }
                    if (item.FilterType == "BlogPost") {

                        $li = $('<li class="BlogItem">').append('<img src="' + item.ImagePath + '" alt="" />');

                        $li.append("<span class='BlogHeader'>" + item.MainValue + "</span>");
                        $li.append("<span>" + item.HexValue + "</span>");
                        $li.append("<span class='Info'></span>");

                        $li.appendTo(ul);

                        return $li;

                    }
                    else
                        if (item.FilterType == "Color") {

                            var colorCode = item.HexValue;
                            //if (!item.HexValue.includes("#")) {
                            //    colorCode = "#" + colorCode;
                            //}

                            $li = $('<li class="ColorItem">').append('<span class="HexItem" style="background-color:' + colorCode + '" alt="" />');

                            $li.append("<div class='ColorHeader'>" + item.MainValue + "</span><span>Renklerde Arayın</span>");
                            $li.append("");
                            $li.append("<span class='Info'></span>");

                            $li.appendTo(ul);

                            return $li;

                        }
                        //else if (item.FilterType == "Tag") {

                        //    return $('<li class="TagItem">')
                        //            .append('<a href="' + "/" + $("#SmallLangCode").val() + "/Tags/" + item.SubValue + '">' + item.MainValue + '</a>')
                        //            .append("<span class='Info'></span>")
                        //            .appendTo(ul);
                        //}
                        else {
                            return $('<li>')
                                .append(item.MainValue)
                                .appendTo(ul);
                        }

                };
            },
            focus: function (event, ui) {

                event.preventDefault();

                $(".SearchModal form input:first").val(ui.item.MainValue);

            }

        });
    }
}

function GetHelp(x) {

    $('.help_div').hide();
    $('.help_' + x).show();


    $('.help_' + x).children("div.subhelp:first").show();


}

function changeSiteLanguage(langID, langCode) {

    var url = "/";
    var Catalogs = $("#PgCatalogs").val().split("/");
    var ctlgs = "";

    for (var i = 0; i < Catalogs.length; i++) {
        if (Catalogs[i].length > 0) {
            ctlgs += "&Cats=" + Catalogs[i];
        }
    }

    $.ajax({
        type: 'get',
        url: '/Home/ChangePageLang',
        data: 'PID=' + $("#PID").val() + "&PgType=" + $("#PgType").val() + "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + "&langID=" + langID + ctlgs + "&langCode=" + langCode,
        success: function (dt) {
            window.l10n.setLanguage(langCode);
            localStorage.removeItem('l10n_lang');

            window.parent.location.href = dt;
        },
        error: function () {
            console.error("Site dili değiştirilemedi");
        }
    });

}

function changeSiteTheme(layout) {

    //var hs = window.location.hash;
    //hs = hs.replace("=", "[_]");
    //hs = hs.replace("&", "[and]")

    $.ajax({
        type: 'get',
        url: '/Home/ChangeTheme',
        data: 'Url=' + window.location.pathname + "&th=" + layout + "&hash=" + window.location.hash,
        success: function (dt) {

            window.parent.location.href = dt;
        }
    });

}

function ShowLangAreaForChange() {


    var userLang = navigator.language || navigator.userLanguage;

    if (userLang != null && userLang != undefined && userLang.length > 2) {

        userLang = userLang.substr(0, 2).toLowerCase();
    }

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowLangSwitch",
        success: function (data) {

            if ($(".LangSelectionArea").length <= 0) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".LangSelectionArea").hasClass("gizle")) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".LangSelectionArea").show();
                }

            } else {

                $(".LangSelectionArea").hide();
            }

        }
    });

}

function ShowCurrencyForChange() {


    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowCurrencySwitch",
        success: function (data) {

            if ($(".CurrrencySelectionArea").length <= 0) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".CurrrencySelectionArea").hasClass("gizle")) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".CurrencySelectionArea").show();
                }


            } else {

                $(".CurrrencySelectionArea").hide();
            }

        }
    });

}

function AddToFavoriteNewMain(ProductID, ColorID) {

    if (ColorID != undefined && ProductID != undefined) {

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
            data: 'colorID=' + ColorID + "&productID=" + ProductID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.Sonuc == true) {

                    //#region Related Datalayer Add To Favorite Operation
                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && window.dataLayer !== null && window.dataLayer !== undefined) {
                        window.dataLayer.push(JSON.parse(dt.Deger8));
                    }
                    //#endregion
                }
                else if (dt.Sonuc == false) {
                    alert(dt.IslemSonucAciklama);

                }
            },
            error: function (httpObj, textStatus) {


                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');

            }
        });
    }

}

var mouse_is_inside_search = false;
var mouse_is_inside_userandBasket = false;
var mouse_is_inside_LeftMenu = false;
var mouse_is_inside_MainMenu = false;

function HideOpenWindows() {

    if (!mouse_is_inside_search) {

        $(".SearchModal").hide();

    }

    if (!mouse_is_inside_userandBasket) {

        $(".RightBasket").removeClass("active");
        $(".RightAccount ").removeClass("active");
        $("ul#MainMenu.Monitor > li").removeClass("open");

    }

    if (!mouse_is_inside_search && !mouse_is_inside_userandBasket && !mouse_is_inside_LeftMenu) {

        //$("body").removeClass("BackDropped");
    }

    if (!mouse_is_inside_MainMenu) {
        $("ul#MainMenu.Monitor > li").removeClass("open");
    }

}

function GetInsiderObjectForHome() {
    var cName = $("#CName").val();
    var phoneNumber = $("#PhoneNumber").val();
    var email = $("#Email").val();
    var pid = 0;
    if ($("#PID").val() != '' || $("#PID").val() != undefined) {
        pid = $("#PID").val();
    }


    var sessionId = getCookie('SessionID');

    if (!sessionId) {
        sessionId = generateUUID();
        setCookie('SessionID', sessionId, 5);
    }

    var userOptinData = JSON.parse(localStorage.getItem('userOptinData')) || {};
    if (cName == "Home" || cName == "Cat") {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/Home/GetInsiderObjectForHome",
            data: {
                Cname: cName || "Page",
                phoneNumber: userOptinData.phone_number || phoneNumber,
                email: userOptinData.email || email,
                sessionId: sessionId,
                pid: pid

            },
            dataType: 'json',
            async: true,
            success: function (dt) {
                //console.log("AJAX Response:", dt);

                window.insider_object = jQuery.parseJSON(dt);

                if ((window.insider_object) && window.insider_object.user != null) {

                    // Eğer uuid varsa, AJAX yanıtındaki bilgileri kullandım.
                    if (window.insider_object.user.uuid) {
                        //  console.log("UUID mevcut, AJAX yanıtından veriler alınacak.");
                        window.insider_object.user = Object.assign({}, window.insider_object.user);
                    } else {
                        // Eğer uuid yoksa, localStorage ve insider_object.user verilerini birleştirdim.
                        // console.log("UUID yok, localStorage'daki verilerle insider_object birleştirilecek.");
                        window.insider_object.user = Object.assign({}, window.insider_object.user, {
                            phone_number: window.insider_object.user.phone_number || userOptinData.phone_number || "",

                            email: window.insider_object.user.email || userOptinData.email || ""

                        });
                    }
                }
                // console.log("Güncellenmiş insider_object:", window.insider_object);
            },
            error: function (err) {
                //  console.error("AJAX isteği sırasında hata oluştu:", err);
            }
        });
    }
}


$('.SearchModal form, .RightSearch').live({
    mouseenter:
        function () {
            mouse_is_inside_search = true;
        },
    mouseleave:
        function () {
            mouse_is_inside_search = false;
        }
});

$('.SubMenuContainer, #MainMenu').live({
    mouseenter:
        function () {
            mouse_is_inside_MainMenu = true;
            $(".FilterOption .slider").hide();
        },
    mouseleave:
        function () {
            mouse_is_inside_MainMenu = false;
            $(".FilterOption .slider").show();
        }
});

$.fn.exists = function () {
    return this.length !== 0;
}

var lastpos = -1;
var width = 0;
var UserValue;

function LeftMenuFixedOptions() {
    $(window).scroll(function () {
        var TopValue = $("footer").height();


        if ($(window).scrollTop() + ($(window).height() + 300) > $(document).height()) {
            //$(".CategoryLeftBar").css("top", "-" + (TopValue) + "px");

        } else {

            $(".CategoryLeftBar").css("top", "inherit");
        }
    });
}


function MobileMenuSetting() {
    $("#MainMenu > ul > li").each(function () {
        if (!$(this).hasClass("TabletMenu")) {
            $(this).addClass("row plus-icon mainItem");

            var dataBanner = $(this).attr("data-banner");
            $a = $(this).children("a");


            $(this).children("a").remove();
            var newa = "";
            if ($(this).find(".itemsWrapper").length > 0) {
                if (dataBanner != null && dataBanner != undefined) {
                    newa = "<a id='" + $a.attr("id") + "' data-rel='" + $a.attr("data-rel") + "' data-name='" + $a.attr("data-name") + "' data-url='" + $a.attr("data-url") + "' href='javascript:;'>" + $a.attr("data-name") + "</a>"; //a arasına dataname yazıldı - mobil menude banner isterlerse kaldır
                }
                else {
                    newa = "<a id='" + $a.attr("id") + "' style='" + $a.attr("style") + "' data-rel='" + $a.attr("data-rel") + "' data-name='" + $a.attr("data-name") + "' data-url='" + $a.attr("data-url") + "' href='javascript:;'>" + $a.html() + "</a>";
                }

            }
            else {
                if (dataBanner != null && dataBanner != undefined) {
                    newa = "<a id='" + $a.attr("id") + "' data-rel='" + $a.attr("data-rel") + "'data-name='" + $a.attr("data-name") + "' data-url='" + $a.attr("data-url") + "' href='" + $a.attr("href") + "'>" + $a.attr("data-name") + "</a>"; //a arasına dataname yazıldı - mobil menude banner isterlerse kaldır
                }
                else {
                    newa = "<a id='" + $a.attr("id") + "' style='" + $a.attr("style") + "' data-rel='" + $a.attr("data-rel") + "'data-name='" + $a.attr("data-name") + "' data-url='" + $a.attr("data-url") + "' href='" + $a.attr("href") + "'>" + $a.html() + "</a>";
                }

            }
            $(this).prepend("<div class='col-xs-24 MainNavItem'>" + newa + "</div>");
        }
    });

    $(".ListWrapper > ul > li").each(function () {

        // Sayfa sitemap mı kontrolü
        var element = $(".Mainmenu");
        var parentElementSitemap = element.parent();
        var isSitemap = false;

        if (parentElementSitemap.hasClass("SitemapMenu")) {
            isSitemap = true;
        }

        if (isSitemap != undefined && isSitemap != null && isSitemap != true) {

            $a = $(this).children("a");

            var mainClass = "<div class='col-xs-20 SubNavItem'>";

            var currentLink = $a.attr("href");

            if ($(this).find(".itemsWrapper").length > 0)
                currentLink = "javascript:;";

            var newa = "<a data-rel='" + $a.attr("data-rel") + "' data-name='" + $a.attr("data-name") + "' href='" + currentLink + "' data-url='" + $a.attr("href") + "'>" + $a.html() + "</a>";
            var newIcon = "";

            if ($(this).find("li").length > 0 && !$(this).hasClass("TabletMenu")) {
                $(this).addClass("plus-icon subItem");
                newIcon = "<div class='col-xs-4 OpenChildrenMenu'><a href='javascript:;'><span class='glyphicon glyphicon-menu-right'></span></a></div>";
            }
            else {
                mainClass = "<div class='col-xs-24 SubNavItem'>";
            }

            $(this).addClass("row");
            $(this).children("a").remove();
            $(this).prepend(mainClass + newa + "</div>" + newIcon);
        }

    });

    $("[data-rel=6]").append(newIcon = "<div class='col-xs-4 OpenChildrenMenu'><span class='glyphicon glyphicon-menu-right'></span></div>");
    $("[data-rel=7]").append(newIcon = "<div class='col-xs-4 OpenChildrenMenu'><span class='glyphicon glyphicon-menu-right'></span></div>");
    $("[data-rel=371]").append(newIcon = "<div class='col-xs-4 OpenChildrenMenu'><span class='glyphicon glyphicon-menu-right'></span></div>");
    $("[data-rel=400]").append(newIcon = "<div class='col-xs-4 OpenChildrenMenu'><span class='glyphicon glyphicon-menu-right'></span></div>");


    document.querySelectorAll('[data-name="T-Shirt"]').forEach(function (el) {
        el.setAttribute('data-name', 'T-Shırt');
        el.innerHTML = "T-Shırt";
    });
}

function ToggleFooterMenu() {
    $(".footerLinks .footerMenu").live("click", function () {
        $(this).find("ul").slideToggle();
    });
}

function Isfollow() {
    var productId = $("#ProductID").val();
    var curColorId = $("#CurrentColorId").val();
    $That = $(".AddToFavorite");

    if (productId != undefined) {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/IsFollow",
            data: 'productId=' + productId + '&currentColorId=' + curColorId,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.IsFollow == true) {
                    $That.removeClass("passiveFavorite");
                    $That.addClass("activeFavorite");
                } else {
                    $That.addClass("passiveFavorite");
                    $That.removeClass("activeFavorite");
                }
            }
        });
    }
}

function AddToCartAreaWidthSet() {

    var $curWidth = $('.PrdImgsBox:first').width();

    //$(".ProductList > div > div.PrdImgsBox .AddToCartArea").css('width', $curWidth);
}

function ToggleSystem() {
    if ($(window).width() <= 991) {
        $(document).on("click", ".ToggleAccountMenu", function (e) {
            $(".AccountMenu").toggle();
        });
    }
}

function AddSearchBox() {
    var searchSelector = SearchBox('.HeaderSearchArea .SearchIcon');
    searchSelector.init();
    window.searchBox = searchSelector;
}
function HeaderLinkClickEvents() {
    $(".RightAccount a").live("click", function () {
        CloseLeftMenu();
    });

    $(".RightBasket a").live("click", function () {
        CloseLeftMenu();
    });
}

function CloseLeftMenu() {
    $("#MainMenu").removeClass("open");
    $("body").removeClass("LeftMenuOpen");
    $("html").removeClass("noScroll");
}

function CloseShowWrapper() {
    $(".Mainmenu .ShowWrapper").each(function () {
        $(this).removeClass("ShowWrapper");
    });

    $("#MainMenu").removeClass("openSub");
}

function CloseSubShowWrapper() {
    $(".ShowWrapper .ShowSubWrapper").each(function () {
        $(this).removeClass("ShowSubWrapper");
    });
}

//catalog ve home sayfalarında görünecek olan, 
//search tarafında ki tasarımsal ve işlevsel düzenlemeler
function HiddenMdLgSearchButton() {

    var url = $(location).attr('href');
    var urlTr = "/tr/";
    var Result = url.indexOf(urlTr);

    if (Result == -1) {
        $('#MobileSearch').show();
        var x = window.matchMedia("(max-width: 991px)");
        //MobileHomeMenuSearch(x);
    }
    else {
        $('#MobileSearch').hide();
        $('.MobileSearchButtonJK').click(function () {
            if ($("#MobileSearch").first().is(':hidden')) {
                $("#MobileSearch").show('fast');
                $('header #MainMenu').css('padding-top', '70px');
            }
            else {
                $("#MobileSearch").slideUp('fast', function () { });

                $('header #MainMenu').css('padding-top', '30px');

            }
        });
    }
}

function GeneralFunction() {
    if (isMobileResolution()) {
        $(".wait-transition").each(function () {
            $(this).addClass("ready-transition").removeClass("wait-transition");
        });
    }

    if ($("button.btn-wait-to-load").length > 0) {
        $("button.btn-wait-to-load").each(function () {
            $(this).removeClass("btn-wait-to-load").attr("disabled", false);
        });
    }
}

// #region Device, Browser, Query, IsNumeric Determination(Old common.js)
function isMobileResolution() {
    if ($(window).width() <= 991) {
        return true;
    }
    else {
        return false;
    }
}
// #endregion

function setBadgeCssTopValue() {
    // text badgeler üst üste gelmemesi için
    var productBadges = document.getElementsByClassName('ProductBadge');

    for (var j = 0; j < productBadges.length; j++) {
        var badges = productBadges[j].getElementsByClassName('text-badge');

        for (var i = 0; i < badges.length; i++) {
            var topValue = 30 + (i * 17); // 30px, 50px, 70px, 90px
            badges[i].style.top = topValue + 'px';
        }
    }
}

// Debounce fonksiyonu, bir işlemi sık sık tetiklenmesini engeller
function debounce(func, delay) {
    var timer;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            func.apply(context, args);
        }, delay);
    };
}

String.prototype.turkishtoEnglish = function () {
    return this.replace(/Ğ/g, 'g')
        .replace(/Ü/g, 'u')
        .replace(/Ş/g, 's')
        .replace(/I/g, 'i')
        .replace(/İ/g, 'i')
        .replace(/i̇/g, 'i')
        .replace(/Ö/g, 'o')
        .replace(/Ç/g, 'c')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's')
        .replace(/ı/g, 'i')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c');
};

// Üye ol modal
function uye_giris_tabli_js() {
    function handleButton() {
        var loginButton = document.getElementById("authentication_tab_menu_button_login");
        var registerButton = document.getElementById("authentication_tab_menu_button_register");
        var loginUnderLine = document.querySelector(".authentication_tab_menu_button_underLine_login");
        var registerUnderLine = document.querySelector(".authentication_tab_menu_button_underLine_register");
        var loginBody = document.getElementById("authentication_tab_menu_body_login");
        var registerBody = document.getElementById("authentication_tab_menu_body_register");

        function handleLoginClick() {
            loginUnderLine.classList.add("authentication_tab_menu_button_underLine_active");
            registerUnderLine.classList.remove("authentication_tab_menu_button_underLine_active");
            loginBody.classList.add("authentication_tab_menu_body_content_active");
            registerBody.classList.remove("authentication_tab_menu_body_content_active");
            registerButton.classList.remove("authentication_tab_menu_button_register_active");
            loginButton.classList.add("authentication_tab_menu_button_login_active");
        }

        if (loginButton) {
            loginButton.addEventListener("click", handleLoginClick);
        }

        var loginIcon = document.querySelector('a.LoginIcon');
        if (loginIcon) {
            loginIcon.addEventListener("click", handleLoginClick);
        }

        function handleRegisterClick() {
            loginUnderLine.classList.remove("authentication_tab_menu_button_underLine_active");
            registerUnderLine.classList.add("authentication_tab_menu_button_underLine_active");
            loginBody.classList.remove("authentication_tab_menu_body_content_active");
            registerBody.classList.add("authentication_tab_menu_body_content_active");
            loginButton.classList.remove("authentication_tab_menu_button_login_active");
            registerButton.classList.add("authentication_tab_menu_button_register_active");
        }

        if (registerButton) {
            registerButton.addEventListener("click", handleRegisterClick);
        }

        var registerIcon = document.querySelector('a.RegisterIcon');
        if (registerIcon) {
            registerIcon.addEventListener("click", handleRegisterClick);
        }
    };

    function handleClose() {
        var close = document.querySelector(".authentication_tab_menu_container_close");
        var closeButton = document.querySelector("#LoginRegisterModal > div > div > div.modal-header > button");
        var container = document.querySelector(".authentication_tab_menu_container");

        var buttonArea = document.querySelector(".authentication_tab_menu_container_close");
        if (buttonArea && closeButton) {
            buttonArea.appendChild(closeButton);
        }

        var buttons = document.querySelectorAll("#UserWelcome a");
        if (buttons) {
            buttons.forEach(function (button) {
                button.addEventListener("click", function () {
                    container.classList.add("authentication_tab_menu_active");
                });
            });
        }
    };

    function appendRegisterForm() {
        var registerForm = document.querySelector("#LoginRegisterModal .register-section");
        var registerBody = document.getElementById("authentication_tab_menu_body_register");

        if (registerBody) {
            registerBody.appendChild(registerForm);
        }
    };

    function appendLoginForm() {
        var loginForm = document.querySelector("#LoginRegisterModal .login-section");
        var loginBody = document.getElementById("authentication_tab_menu_body_login");

        if (loginBody) {
            loginBody.appendChild(loginForm);
        }
    };

    function removeTitle() {
        if (window.innerWidth < 991) {
            var titles = document.querySelectorAll("#LoginRegisterModal .title");
            titles.forEach(function (item) {
                item.style.display = "none";
            });
        }
    };

    function removeHeader() {
        var modalHeader = document.querySelector("#LoginRegisterModal .modal-header");
        if (modalHeader) {
            modalHeader.style.display = "none";
        }
    };

    function handleCheckOrginal() {
        document.addEventListener("click", function (event) {
            if (event.target.id === "nextbtn" || event.target.id === "NextBackButtons") {
                var body = document.querySelector("body");
                var authenticationTabMenuContainer = document.querySelector(".authentication_tab_menu_container");

                setInterval(function () {
                    setTimeout(function () {
                        if (body.classList.contains("modal-open") && !authenticationTabMenuContainer.classList.contains("authentication_tab_menu_active")) {
                            authenticationTabMenuContainer.classList.add("authentication_tab_menu_active");
                        }
                    }, 100);
                }, 100);
            }
        });
    };

    function handleChangeHtmlToButton() {
        var button = document.querySelector(".authentication_tab_menu_container_close button");

        if (button) {
            button.innerHTML = '<img src="https://anatomi.s3.eu-north-1.amazonaws.com/carpi.png" alt="" />';
        }
    };

    function handleAddTextBetweenButtons() {
        var buttonArea = document.querySelector("#sendConfirmationSmsCode");

        var text = document.createElement("p");
        text.classList.add("authentication_buttons_text");
        text.innerHTML = "&";

        if (buttonArea) {
            buttonArea.insertAdjacentElement("afterend", text);
        }
    };

    function checkModal() {
        //if (window.innerWidth < 991) {
        var body = document.querySelector("body");
        setInterval(function () {
            if (body.classList.contains("modal-open") && document.querySelector(".authentication_tab_menu_container") && !document.querySelector(".authentication_tab_menu_container").classList.contains("authentication_tab_menu_active")) {
                var authenticationTabMenuContainer = document.querySelector(".authentication_tab_menu_container");
                authenticationTabMenuContainer.classList.add("authentication_tab_menu_active");
            }
        }, 100);
        //}
    };

    checkModal();
    handleButton();
    handleClose();
    appendRegisterForm();
    appendLoginForm();
    removeTitle();
    removeHeader();
    handleCheckOrginal();
    handleChangeHtmlToButton();
    handleAddTextBetweenButtons();
};

var loginRegisterModal = document.getElementById("LoginRegisterModal");

if (loginRegisterModal) {
    uye_giris_tabli_js();
}
function updateInsiderObjectIfChanged(jsonString) {
    if (!jsonString) return;

    try {
        var parsed = JSON.parse(jsonString);
        if (JSON.stringify(window.insider_object) !== JSON.stringify(parsed)) {
            console.log("Insider güncelleniyor (tek sefer):", parsed);
            window.insider_object = parsed;
        } else {
            console.log("Insider güncellemesi atlandı, veri zaten aynı.");
        }
    } catch (e) {
        console.error("Insider JSON parse hatası:", e);
    }
}



$(document).ready(function () {
    // FS#13387 - Kaydırma Performansını Artırmak İçin Pasif İşleyici Kullanmak
    document.addEventListener('touchstart', function (event) { }, { passive: true });
    document.addEventListener('touchmove', function (event) { }, { passive: true });
    document.addEventListener('scroll', function (event) { }, { passive: true });
    document.addEventListener('mouseup', function (event) { }, { passive: true });

    GeneralFunction();
    HiddenMdLgSearchButton();
    ToggleSystem();
    AddSearchBox();
    GetInsiderObjectForHome();
    //setBadgeCssTopValue();

    var langCode = $("#SmallLangCode").val() || "tr";

    // Eğer localStorage'daki dil farklıysa güncelle ve sayfayı yenile
    var savedLang = localStorage.getItem("lang") || "tr";

    if (savedLang !== langCode) {
        localStorage.setItem("lang", langCode);
    }

    window.l10n = $('body').l10n({
        dictList: words,
        lang: langCode
    });

    // Sadece dil değiştiğinde `setLanguage` çağrılsın
    if (savedLang !== langCode) {
        window.l10n.setLanguage(langCode);
    }

    $(document).on("click", "#UserAndBasket .RightGlobal > .langSwitchContainer ul li", function () {

        var id = $(this).attr('data-value');

        var code = $(this).attr('data-code');

        changeSiteLanguage(id, code);
    });

    $(document).on("click", "#UserAndBasket .RightGlobal > a", function () {
        toggleGlobal();
    });

    //var showTopLink = 100;
    //var windowWidth = $(window).width();
    //var extraHeight = $('#MainMenu .Mainmenu').height() + $('#AnoncementArea').height() + showTopLink + 10;

    //$(window).on('scroll', function () {
    //    if (windowWidth > 767 && $('.top_link').length > 0) {
    //        if (scrollTop > showTopLink) {
    //            if (!$('.top_link').is(':visible')) {
    //                $('.top_link').fadeIn('slow');
    //            }
    //        } else {
    //            if ($('.top_link').is(':visible')) {
    //                $('.top_link').fadeOut('slow');
    //            }
    //        }
    //    }

    //    if (windowWidth > 992) {
    //        var scrollTop = $(window).scrollTop();

    //        if (scrollTop > showTopLink && scrollTop < extraHeight) {

    //        }
    //        else if (scrollTop > extraHeight && !$("body").hasClass("up")) {
    //            $('#AnoncementArea').slideUp("fast");
    //            $('#MainMenu .Mainmenu').slideUp("fast", function () {
    //                $("body").addClass("Scrolled");
    //            });
    //        }
    //        else if (scrollTop < showTopLink) {
    //            $('#MainMenu .Mainmenu').slideDown("fast");
    //            $('#AnoncementArea').slideDown("fast", function () {
    //                $("body").removeClass("Scrolled");
    //            }); 
    //        }
    //    }
    //});

    var windowWidth = $(window).width();
    var lastScrollTop = 0;
    var extraHeight = $('#MainMenu .Mainmenu').height() + $('#AnoncementArea').height() + 50;

    window.addEventListener("scroll", function () {
        var st = window.pageYOffset || document.documentElement.scrollTop;

        if (st < extraHeight) {
            if ($('.top_link').is(':visible')) {
                $('.top_link').fadeOut('slow');
            }

            return;
        }

        if (st > lastScrollTop) {
            //if (windowWidth > 992) {
            //    $('#MainMenu .Mainmenu').slideUp("fast");
            //}

            $('#AnoncementArea').slideUp("fast");
            $("body").removeClass("ScrollUp").addClass("ScrollDown");
            lastScrollTop = st <= 0 ? 0 : st;
        }

        else if (st < (lastScrollTop - extraHeight)) {
            //if (windowWidth > 992) {
            //    $('#MainMenu .Mainmenu').slideDown("fast");
            //}

            $('#AnoncementArea').slideDown("fast");
            $("body").removeClass("ScrollDown").addClass("ScrollUp");
            lastScrollTop = st <= 0 ? 0 : (st + extraHeight);
        }

        if (st > 100 && !$('.top_link').is(':visible')) {
            $('.top_link').fadeIn('slow');
        }

    }, false);

    if ($(window).width() < 991) {
        var mobileContainer = document.querySelector('.mobile-container');

        if (mobileContainer) {
            var mobileContainerHeight = mobileContainer.offsetHeight;

            var mainMenu = document.querySelector('#MainMenu');

            if (mainMenu) {
                mainMenu.style.top = mobileContainerHeight + 'px';
            }
        }
    }

    $(".sb .searchIcons").on('click', function () {
        $(this).closest('form').submit();
    });

    $("#togglePasswordEye").on('click', function (e) {
        const password = document.querySelector('#Password');

        const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
        password.setAttribute('type', type);

        // toggle the eye slash icon
        $("#togglePasswordEye").toggleClass('eyeSlashIcon');
    });

    $("#togglePasswordEyeConfirm").on('click', function (e) {
        const password = document.querySelector('#ConfirmPassword');

        const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
        password.setAttribute('type', type);

        // toggle the eye slash icon
        $("#togglePasswordEyeConfirm").toggleClass('eyeSlashIcon');
    });


    $('.FooterTextShowMore').on('click', function (e, index) {

        $(this).hide();
        $('.FooterTextShowLess').show();
        $('.FooterTextSecondPart').show();
    });

    if ($(window).width() < 991) {
        $("#MainMenu > ul > li > .itemsWrapper").closest("a").attr("href", "javascript:;");
    }

    //if (document.URL.indexOf("/outlet") != -1 && $("#MainMenu .outlet").length > 0) {
    //    $("#MainMenu .outlet").show();
    //    $("#MainMenu .outlet").prev().hide();
    //}

    $("#MainMenu > ul > li > .itemsWrapper > .ListWrapper").each(function () {
        var that = $(this);
        if (that.find(" ul > li > .itemsWrapper").length <= 0) {
            //Sub Head doesnt Contains
            that.parent().addClass("SubHeadDCItems");
        }
    });

    $("#MainMenu > ul > li").on("mouseover", function () {
        $($(this).children(".itemsWrapper").children(".ListWrapper").children("ul").children("li")).each(function (i) {
            if ($(this).find("div").length > 0) {
                $(this).parent().css('font-weight', 'bold');
            }
            else {
                $(this).children().css('font-weight', 'normal');
                $(this).children().css('text-transform', 'none');
            }
        });
    });

    $('.FooterTextShowLess').on('click', function (e, index) {

        $(this).hide();
        $('.FooterTextShowMore').show();
        $('.FooterTextSecondPart').hide();

    });

    $(".SepetProducts .closeImage").live("click", function () {
        toggleBasket();
        $(".SepetProducts").removeClass("activeBasket");
        $("body").removeClass("BasketDropped");
        $("body").removeClass("BackDropped");
    });

    $("#MainMenu > ul > li").on("click", function () {
        if ($(window).width() < 992 && !$(this).hasClass("TabletMenu") && !$(this).find(".itemsWrapper").length <= 0) {
            //$(this).find(".itemsWrapper").slideToggle();
            //$(this).toggleClass("minus-icon");
        }
    });

    if (isMobile(true) && $(window).width() < 991) {
        MobileMenuSetting();
    }

    LeftMenuFixedOptions();

    //AddToFavorite();
    //removeFavorite();
    Isfollow();

    if ($(window).width() < 992) {
        ToggleFooterMenu();
    }

    $("a#ContinueShop").live("click", function () {
        location.reload();
    });

    //NewsletterPopupControl();

    $('.top_link').hide();
    width = $(window).width();

    $('.OpenLeftMenu').hover(function () {
        mouse_is_inside_LeftMenu = true;
    }, function () {
        mouse_is_inside_LeftMenu = false;
    });

    $('.UserAndBasket, .BasketContainer').live({
        mouseenter:
            function () {

                mouse_is_inside_userandBasket = true;

            },
        mouseleave:
            function () {
                mouse_is_inside_userandBasket = false;
            }
    });

    var ThemePath = "/Images/BlackTheme/";

    if ($(".LogoContainer img").length > 0) {
        ThemePath = $(".LogoContainer img:first").attr("src").replace("Logo.png", "");
    }

    //Menu 
    if ($("ul#MainMenu").length > 0) {
        //$("ul#MainMenu").ResponsiveMenu();
    }

    // alert("ismobile:" + isMobile(true) + " IsChrome:" + IsChrome() + " IsFirefox:" + IsFirefox() + "IsSafari:" + IsSafari() + " agent:" + navigator.userAgent.toLowerCase() );

    //if (isMobile(true) && (IsChrome() || IsFirefox() || IsSafari())) {
    //    $("#MainMenu").css("display", "block");
    //}

    $('.carousel').carousel({
        interval: false,
        keyboard: false
    });

    $(".carousel .hidden-xs").removeClass("hidden-xs");

    $(".carousel").swiperight(function (e) {//lazım olursa ekleriz   .die("swiperight").live("swiperight", function () {
        $(this).carousel('prev');
        e.preventDefault();
        return false;
    });
    $(".carousel").swipeleft(function (e) {//.die("swipeleft").live("swipeleft", function () {
        $(this).carousel('next');
        e.preventDefault();
        return false;
    });

    //$("#MainMenu.Monitor > li:has('.BWOSubMenuShow'), .RightBasket, .RightAccount").live({
    $("#MainMenu.Monitor > li:has('.BWOSubMenuShow')").live({
        mouseenter:
            function () {
                if (!isMobile(true)) {
                    $("body").addClass("BackDropped");
                }
            },
        mouseleave:
            function () {
                if (!isMobile(true) && $(".SearchModal").css("display") != "block") {
                    $("body").removeClass("BackDropped");
                    $(".SepetProducts").removeClass("activeBasket");
                    $("ul#MainMenu.Monitor > li").removeClass("open");
                }
            }
    });

    //$("body.BackDropped:not(.OpenLeftMenu)").live("click", function () {
    //    HideOpenWindows();
    //});

    //$("body.BackDropped:not(.BasketContainer)").live("click", function () {

    //    if ($(".RightBasket.active").length > 0) {
    //        $(".RightBasket").removeClass("active");
    //    }

    //    if ($(".RightBasket.active").length > 0) {
    //        $(".RightBasket").removeClass("active");
    //    }

    //});

    //$("body .backdrop").on("click", function (e) {

    //    HideOpenWindows();

    //    $("body").removeClass("LeftMenuOpen BackDropped");
    //    $("#MainMenu").removeClass("open");
    //    //$(".SearchModal").hide();
    //    $(".RightBasket, .RightAccount").removeClass("active");
    //    $(".SepetProducts").removeClass("activeBasket");

    //});

    $("body .backdrop").on("click", function (e) {

        HideOpenWindows();

        $("body").removeClass("LeftMenuOpen BackDropped");
        $("#MainMenu").removeClass("open");

        $("body").removeClass("BasketDropped");
        hideBasket();
        //$(".SearchModal").hide();
        $(".RightBasket, .RightAccount").removeClass("active");
        $(".SepetProducts").removeClass("activeBasket");

    });

    $("body").on("click", function (e) {

        if (!mouse_is_inside_userandBasket) {
            $(".RightBasket.active").removeClass("active");
        }


    });

    $("body #PrdBlackBg").on("click", function (e) {

        $("#PrdBlackBg").hide();
        $(".SizeOptions.open").removeClass("PleaseSelect");
        $(".AddToBasket.PleaseSelect").removeClass("PleaseSelect");

        if ($(".AutoTextRep").length > 0) {
            $(".AutoTextRep button").text($(".AutoTextRep button").attr("data-first"));
        }
    });

    $('.top_link').click(function () {

        $('html, body').animate({ scrollTop: 0 }, 'slow');

    });

    var rtime;
    var timeout = false;
    var delta = 500;

    $(window).resize(function () {

        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(resizeend, delta);
        }
    });

    function resizeend() {
        if (new Date() - rtime < delta) {
            setTimeout(resizeend, delta);
        } else {
            timeout = false;
        }
    }

    $('.footerMenu .mainHead').click(function () {

        $(this).parent().toggleClass("open");

    });

    $("#CurrencySelectionDr").on("click", ".CurrencyItem", function () {

        var hs = window.location.hash;
        hs = hs.replace("=", "[_]");
        hs = hs.replace("&", "[and]")
        var CurrencyID = $(this).attr("data-id");

        $(".CurrenctCur img").attr("src", $(this).find("img").attr("src"));
        $(".CurrenctCur .TL").html($(this).find(".TL").html());
        $(".CurrenctCur .CurrCode").html($(this).find(".CurrCode").html());

        $.ajax({
            type: 'get',
            url: '/Home/ChangeCurrency',
            data: 'Url=' + window.location.pathname + "&currencyID=" + CurrencyID + "&hash=" + window.location.hash,
            success: function (dt) {

                window.location.reload(true);

            }
        });


    });

    $(".CloseModal").on("click", function () {
        $(this).parents(".modal").modal('hide');
    });

    $(".CloseModal").on("click", function () {
        $(this).parents(".modal").modal('hide');
    });


    $(".btn-back").live("click", function () {

        $(this).closest("form").slideUp();

    });

    $(".login-tabs").on("hidden.bs.tab", function (e) {
        var activeTab = $(this).children(".active");

        if (activeTab.hasClass("register-tab")) {
            $(".login-register-left").removeClass("hidden");
        }
        else {
            $(".login-register-left").addClass("hidden");
        }
    });

    $('body').on('hidden.bs.modal', '.modal', function () {
        $(this).removeData('bs.modal');
    });

    //$('.help_Uyelik, .help_Uyelik .subhelp').hide();
    $('.help_Uyelik, .help_Uyelik .subhelp:first').show();
    $('#helpMenu ul li:first a').addClass("secili");

    //if ($('.helpmenu li a').length > 0) {

    //Help Menu

    $('#helpMenu ul li a').on('click', function (e, index) {

        $('#helpMenu ul li a').removeClass('secili');
        $(this).addClass('secili');
        GetHelp($(this).attr('href').replace(/#/ig, ""));
    });

    $('.subhelptitle').on('click', function (e, index) {


        var c = $(this).attr('id').replace(/title/, "");
        $('.subhelp:visible').slideUp('fast');
        $('.' + c).slideDown('fast');

    });

    $("#HelpNavs div ul").first().show();
    $("#HelpContents ul li").hide();
    $("#HelpContents div").eq($("#HelpNavs div .HelpNavTitles").first().parent().index()).find("ul li:first").show();


    $('#HelpNavs li').click(function () {

        $("#HelpContents ul li").hide();

        $("#HelpContents div").eq($(this).closest("div").index()).find("ul li").eq($(this).index()).show();

    });

    $('#HelpNavs > div').click(function () {


        $("#HelpNavs div > ul").hide();
        $(this).find("ul").show("normal");


    });

    $('.HelpNavTitles').click(function () {

        $("#HelpContents ul li").hide();
        $("#HelpContents div").eq($(this).parent().index()).find("ul li:first").show();

    });


    function hideBasket() {
        $(".SepetProducts").stop().animate({ "left": "100%" }, 200, function () {
            $(".SepetProducts").stop().hide();
            $("body").removeClass("BasketDropped");
        });
    }

    function showBasket() {

        if ($(window).width() > 1199 && $(window).width() > 1510) {
            $(".SepetProducts").stop().animate({ "left": "75%" }, 200, function () {
                setContentHeight();
                $(".SepetProducts").stop().show();
                $("body").addClass("BasketDropped");
            });
        } else {
            $(".SepetProducts").stop().animate({ "left": "75%" }, 200, function () {
                setContentHeight();
                $(".SepetProducts").stop().show();
                $("body").addClass("BasketDropped");
            });
        }

    }

    $('.RightBasket').live('click', function (e) {

        e.preventDefault;
        //if (isMobile(true)) {

        var isCartActive = $(".RightBasket").hasClass("active");

        $("body").addClass("BasketDropped");

        $(".RightBasket").addClass("active");
        $(".RightAccount").removeClass("active");

        toggleBasket();

        if (!isCartActive) {
            e.preventDefault;
            return false;
        }

        //}

    });

    //--


    //$('.RightAccount').live('click', function (e) {
    //    if (isMobile(true)) {
    //        var isCartActive = $(".RightAccount").hasClass("active");
    //        //$("body").addClass("BackDropped");
    //        //$(".RightAccount").addClass("active");
    //        //$(".RightBasket").removeClass("active");
    //        if (!isCartActive) {
    //            e.preventDefault;
    //            return false;
    //        }
    //    }
    //});


    if ($("#UserAndBasket").length > 0) {

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
            data: "",
            async: true,
            cache: false,
            contentType: "application/json; charset=utf-8",
            dataType: 'text',
            success: function (dt) {
                $("#UserAndBasket").html(dt);

                TagAutoComplate();

                if ($("#LangRedirectNeed").length > 0) {
                    //  changeSiteLanguage("0", $("#LangRedirectNeed").val());
                }

                if ($("#LangSelectionNeed").length > 0) {
                    ShowLangAreaForChange();
                }

                var UserID = $("#UserID").val();

                if (UserID != undefined && UserID > 0) {
                    Isfollow();
                }

                if (UseTagManager) {
                    AddGeneralInfoTagManager('', dtIsLogged, dtUserID);

                    AddProductView('');
                    var promotions = GetPromotionsVariable('');
                    AddImpression('', promotions);
                    //  AddGASliderView('');

                    SendGaDataLayerVirtual();
                }
            }
        });
    }

    //function setBasketContainerHeight() {
    //    var ContentHeight = $(".SepetProducts").height() - 140;
    //    $(".BasketCenterContent").height(ContentHeight);
    //    $(".BasketCenterContent").css("max-height", ContentHeight);

    //    $(window).resize(function () {
    //        var ContentHeight = $(".SepetProducts").height() - 140;
    //        $(".BasketCenterContent").height(ContentHeight);
    //        $(".BasketCenterContent").css("max-height", ContentHeight);
    //    });
    //}

    $(".BasketContainer .RemoveIcon").live("click", function () {

        var ProductCode = $(this).attr("data-productcode");
        var ProductName = $(this).attr("data-productname");
        var ColorName = $(this).attr("data-colorname");
        var quantity = $(this).attr("data-quantity");
        var price = $(this).attr("data-amount");
        var priceOld = $(this).attr("data-amountPsf");
        var discount = $(this).attr("data-discount");
        var category1 = $(this).attr('data-category1');
        var category2 = $(this).attr('data-category2');
        var category3 = $(this).attr('data-category3');
        var catID = $(this).attr('data-catID');
        var itemListName = $(this).attr('data-itemListName');

        discount = priceOld - price;
        if (price == priceOld) {
            discount = 0;
        }

        var amount = price;
        if (amount == 0) {
            amount = priceOld;
        }

        var value = parseFloat(amount);

        var storedCatalog = localStorage.getItem('selectedCatalog');
        var storedCatalogID = localStorage.getItem('selectedCatalogID')

        window.dataLayer = window.dataLayer || [];
        if (window.dataLayer) {
            try {
                window.dataLayer.push({
                    event: "remove_from_cart",
                    ecommerce: {
                        items: [
                            {
                                item_id: ProductCode,
                                item_name: ProductName,
                                affiliation: category1,
                                coupon: '',
                                currency: 'TRY',
                                discount: discount,
                                index: 0,
                                item_brand: 'JMK',
                                item_category: category1,
                                item_category2: category2,
                                item_category3: category3,
                                item_list_id: parseInt(storedCatalogID),
                                item_list_name: storedCatalog,
                                item_variant: ColorName.split('-')[0],
                                location_id: 'İZ',
                                price: parseFloat(priceOld),
                                quantity: 1
                            }]
                    }
                });
            } catch (e) {
                
            }
        }
        

        var Silid = $(this).attr("data-id").replace("sepetsil", "");
        var pid = $(this).attr("data-productid");
        var LangID = $("#LangID").val();
        var ColorID = $(this).attr("data-colorid");

        $("#DeleteAndAddFavorite button.btn").attr("data-productcode", ProductCode);
        $("#DeleteAndAddFavorite button.btn").attr("data-productname", ProductName);
        $("#DeleteAndAddFavorite button.btn").attr("data-colorname", ColorName);
        $("#DeleteAndAddFavorite button.btn").attr("data-quantity", quantity);
        $("#DeleteAndAddFavorite button.btn").attr("data-amount", price);
        $("#DeleteAndAddFavorite button.btn").attr("data-amountPsf", priceOld);
        $("#DeleteAndAddFavorite button.btn").attr("data-discount", discount);
        $("#DeleteAndAddFavorite button.btn").attr("data-category1", category1);
        $("#DeleteAndAddFavorite button.btn").attr("data-category2", category2);
        $("#DeleteAndAddFavorite button.btn").attr("data-category3", category3);
        $("#DeleteAndAddFavorite button.btn").attr("data-catID", catID);
        $("#DeleteAndAddFavorite button.btn").attr("data-itemListName", itemListName);
        $("#DeleteAndAddFavorite").find("#deleteCart").attr("data-id", Silid);
        $("#DeleteAndAddFavorite").find("#addFavorite").attr("data-id", Silid);
        $("#DeleteAndAddFavorite").find("#addFavorite").attr("data-productid", pid);
        $("#DeleteAndAddFavorite").find("#deleteCart").attr("data-langid", LangID);
        $("#DeleteAndAddFavorite").find("#addFavorite").attr("data-langid", LangID);
        $("#DeleteAndAddFavorite").find("#addFavorite").attr("data-colorid", ColorID);

        $('#DeleteAndAddFavorite').modal("show");


    });

    $("#DeleteAndAddFavorite .deleteCart").live("click", function () {
        $('#DeleteAndAddFavorite').modal("hide");
        var Silid = 0;

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {

            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }
        var ColorId = $(this).attr("data-colorid");
        var ProductId = $(this).attr("data-productid");
        var gizlenecekSecim = $(this).parent().parent();
        var nameOfCurItem = "";
        if ($(this).closest(".SepetRow").length > 0) {

            gizlenecekSecim = $(this).closest(".SepetRow");
            nameOfCurItem = $(gizlenecekSecim).find(".SepetPrdHeader").text();
        }
        var LangID = $("#LangID").val();

        $(gizlenecekSecim).find(".ustSepetAjaxLoader").show();
        $(gizlenecekSecim).find(".ustSepetDelete").hide();
        //$(gizlenecekSecim).css("opacity", "0.5");

        dataall = "";

        if ($(this).attr("data-all") == "true") {

            dataall = "&all=true";
            gizlenecekSecim = $(".SepetProducts");
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }


        $removedItem = $(gizlenecekSecim).clone();

        $.ajax({
            type: 'get',
            url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
            data: 'id=' + Silid + "&langID=" + LangID + dataall,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {
                if (dt.Sonuc == true) {

                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && dt.Deger8 !== '') {

                        var _customModels = dt.Deger8.split("<InsiderObjectBeginning>");

                        if (_customModels !== null) {

                            //#region Related Datalayer Add To Basket Operation
                            if (window.dataLayer !== null && window.dataLayer !== undefined) {
                                var _dataLayerObject = _customModels[0];

                                if (_dataLayerObject !== null && _dataLayerObject !== undefined && _dataLayerObject !== '') {
                                    window.dataLayer.push(JSON.parse(_dataLayerObject));
                                }
                            }
                            //#endregion

                            //#region Insider Object Add To Basket Operation
                            //if (window.insider_object !== null && window.insider_object !== undefined) {
                            //    var _insiderObject = _customModels[1];

                            //    if (_insiderObject !== null && _insiderObject !== undefined && _insiderObject !== '') {
                            //        window.insider_object = JSON.parse(_insiderObject);
                            //    }
                            //}
                            updateInsiderObjectIfChanged(_customModels[1]);
                            //#endregion
                        }
                    }

                    $.ajax({
                        type: 'get',
                        url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                        data: "",
                        async: true,
                        contentType: "application/json; charset=utf-8",
                        dataType: 'text',
                        success: function (dt) {
                            $("#UserMenus  #UserAndBasket").html(dt);

                            $('html, body').animate({ scrollTop: 0 }, 'slow');

                            $(".RightBasket").addClass("active");
                            $("body").addClass("BackDropped");

                            $(".SepetProducts").hide();
                            $(".SepetButton a").trigger("click");
                            setContentHeight();
                            //setBasketContainerHeight();
                            $(".AjaxLoader").hide();
                        }
                    });
                }
                else {
                    alert(dt.IslemSonucAciklama);
                }
            }
        });

    });

    $("#DeleteAndAddFavorite .addFavorite").live("click", function () {
        var Silid = 0;
        $('#DeleteAndAddFavorite').modal("hide");

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {

            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }
        var ColorId = $(this).attr("data-colorid");
        var ProductId = $(this).attr("data-productid");
        var gizlenecekSecim = $(this).parent().parent();
        var nameOfCurItem = "";
        if ($(this).closest(".SepetRow").length > 0) {

            gizlenecekSecim = $(this).closest(".SepetRow");
            nameOfCurItem = $(gizlenecekSecim).find(".SepetPrdHeader").text();
        }
        var LangID = $("#LangID").val();
        var ProductCode = $(this).attr("data-productcode");
        var ProductName = $(this).attr("data-productname");
        var ColorName = $(this).attr("data-colorname");
        var price = parseFloat($(this).attr("data-amount"));
        var priceOld = parseFloat($(this).attr("data-amountPsf"));
        var discount = $(this).attr("data-discount");
        var category1 = $(this).attr('data-category1');
        var category2 = $(this).attr('data-category2');
        var category3 = $(this).attr('data-category3');
        var catID = $(this).attr('data-catID');
        var quantity = $(this).attr("data-quantity");
        var itemListName = $(this).attr('data-itemListName');

        discount = priceOld - price;
        if (price == priceOld) {
            discount = 0;
        }

        var amount = price;
        if (amount == 0) {
            amount = priceOld;
        }

        var value = parseFloat(amount);

        $(gizlenecekSecim).find(".ustSepetAjaxLoader").show();
        $(gizlenecekSecim).find(".ustSepetDelete").hide();
        //$(gizlenecekSecim).css("opacity", "0.5");

        dataall = "";

        if ($(this).attr("data-all") == "true") {

            dataall = "&all=true";
            gizlenecekSecim = $(".SepetProducts");
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }

        $removedItem = $(gizlenecekSecim).clone();

        $.ajax({
            type: 'get',
            url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
            data: 'id=' + Silid + "&langID=" + LangID + dataall,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {
                var storedCatalog = localStorage.getItem('selectedCatalog');
                var storedCatalogID = localStorage.getItem('selectedCatalogID');                

                window.dataLayer = window.test || [];
                if (window.dataLayer) {
                    try {
                        dataLayer.push({
                            event: "add_to_wishlist",
                            ecommerce: {
                                currency: 'TRY',
                                value: value,
                                items: [
                                    {
                                        item_id: ProductCode,
                                        item_name: ProductName,
                                        affiliation: category1,
                                        coupon: "",
                                        currency: 'TRY',
                                        discount: discount,
                                        index: 0,
                                        item_brand: 'JMK',
                                        item_category: category1,
                                        item_category2: category2,
                                        item_category3: category3,
                                        item_list_id: parseInt(storedCatalogID),
                                        item_list_name: storedCatalog,
                                        item_variant: ColorName,
                                        location_id: 'İZ',
                                        price: priceOld,
                                        quantity: 1
                                    }
                                ]
                            }
                        });
                    } catch (e) {

                    }
                }

                if (dt.Sonuc == true) {

                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && dt.Deger8 !== '') {

                        var _customModels = dt.Deger8.split("<InsiderObjectBeginning>");

                        if (_customModels !== null) {

                            //#region Related Datalayer Add To Basket Operation
                            if (window.dataLayer !== null && window.dataLayer !== undefined) {
                                var _dataLayerObject = _customModels[0];

                                if (_dataLayerObject !== null && _dataLayerObject !== undefined && _dataLayerObject !== '') {
                                    window.dataLayer.push(JSON.parse(_dataLayerObject));
                                }
                            }
                            //#endregion

                            //#region Insider Object Add To Basket Operation
                            //if (window.insider_object !== null && window.insider_object !== undefined) {
                            //    var _insiderObject = _customModels[1];

                            //    if (_insiderObject !== null && _insiderObject !== undefined && _insiderObject !== '') {
                            //        window.insider_object = JSON.parse(_insiderObject);
                            //    }
                            //}
                            updateInsiderObjectIfChanged(_customModels[1]);
                            //#endregion
                        }
                    }

                    $.ajax({
                        type: 'get',
                        url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                        data: "",
                        async: true,
                        contentType: "application/json; charset=utf-8",
                        dataType: 'text',
                        success: function (dt) {
                            $("#UserMenus  #UserAndBasket").html(dt);

                            $('html, body').animate({ scrollTop: 0 }, 'slow');

                            $(".RightBasket").addClass("active");
                            //$("body").addClass("BackDropped");

                            $(".SepetProducts").hide();
                            $(".SepetButton a").trigger("click");
                            setContentHeight();
                            //setBasketContainerHeight();
                            $(".AjaxLoader").hide();
                        }
                    });
                }
                else {
                    alert(dt.IslemSonucAciklama);
                }
            }
        });

        AddToFavoriteNewMain(ProductId, ColorId);



    });


    $(".BasketContainer .RemoveIcosn").live("click", function () {

        var Silid = 0;

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {

            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }

        var gizlenecekSecim = $(this).parent().parent();
        var nameOfCurItem = "";
        if ($(this).closest(".SepetRow").length > 0) {

            gizlenecekSecim = $(this).closest(".SepetRow");
            nameOfCurItem = $(gizlenecekSecim).find(".SepetPrdHeader").text();
        }
        var LangID = $("#LangID").val();

        $(gizlenecekSecim).find(".ustSepetAjaxLoader").show();
        $(gizlenecekSecim).find(".ustSepetDelete").hide();
        $(gizlenecekSecim).css("opacity", "0.5");

        dataall = "";

        if ($(this).attr("data-all") == "true") {

            dataall = "&all=true";
            gizlenecekSecim = $(".SepetProducts");
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }

        $removedItem = $(gizlenecekSecim).clone();

        $.ajax({
            type: 'get',
            url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
            data: 'id=' + Silid + "&langID=" + LangID + dataall,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {
                if (dt.Sonuc == true) {

                    if (dt.Deger8 !== null && dt.Deger8 !== undefined && dt.Deger8 !== '') {

                        var _customModels = dt.Deger8.split("<InsiderObjectBeginning>");

                        if (_customModels !== null) {

                            //#region Related Datalayer Add To Basket Operation
                            if (window.dataLayer !== null && window.dataLayer !== undefined) {
                                var _dataLayerObject = _customModels[0];

                                if (_dataLayerObject !== null && _dataLayerObject !== undefined && _dataLayerObject !== '') {
                                    window.dataLayer.push(JSON.parse(_dataLayerObject));
                                }
                            }
                            //#endregion

                            //#region Insider Object Add To Basket Operation
                            //if (window.insider_object !== null && window.insider_object !== undefined) {
                            //    var _insiderObject = _customModels[1];

                            //    if (_insiderObject !== null && _insiderObject !== undefined && _insiderObject !== '') {
                            //        window.insider_object = JSON.parse(_insiderObject);
                            //    }
                            //}
                            updateInsiderObjectIfChanged(_customModels[1]);
                            //#endregion
                        }
                    }

                    $.ajax({
                        type: 'get',
                        url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                        data: "",
                        async: true,
                        contentType: "application/json; charset=utf-8",
                        dataType: 'text',
                        success: function (dt) {
                            $("#UserMenus  #UserAndBasket").html(dt);

                            $('html, body').animate({ scrollTop: 0 }, 'slow');

                            $(".RightBasket").addClass("active");
                            $("body").addClass("BackDropped");

                            $(".SepetProducts").hide();
                            $(".SepetButton a").trigger("click");
                            setContentHeight();
                            //setBasketContainerHeight();
                            $(".AjaxLoader").hide();
                        }
                    });
                }
                else {
                    alert(dt.IslemSonucAciklama);
                }
            }
        });
    });

    if (isMobile(true)) {
        $("#PayNow").live("mouseenter", function (e) {

            document.location.href = $(this).attr("href");

        });
    }

    $('.RightSearch').live('click', function (e) {
        console.info($("body").hasClass("Scrolled"))
        if ($("body").hasClass("Scrolled")) {

            $("body").addClass("Scrolled");
            $("body").addClass("BackDropped");

        }
        else {
            $("body").addClass("BackDropped");
        }


        $(".SearchModal").show();

        $(".SearchModal input:first").focus();
        $('html, body').animate({ scrollTop: 0 }, 'slow');


    });

    $('.headerSearchButton').live('click', function (e) {

        $("body").addClass("BackDropped");
        $(".SearchModal").show();

        $(".SearchModal input:first").focus();
        $('html, body').animate({ scrollTop: 0 }, 'slow');


    });

    $('.OpenLeftMenu, .CloseLeftMenu, .ToggleMMenuIcon , .MainIcon').live('click', function (e) {
        $("#Mainmenu ul li div.itemsWrapper").hide();
        $("#MainMenu").toggleClass("open");
        if ($("#MainMenu").hasClass("open") == true) {

            $("#MainMenu > ul > li:not(.TabletMenu):not(.SearchInMenu):not(.MobileUserMenu)").each(function () {
                //$(this).find("a:first").html("&nbsp;");

                var BackgroundBanner = $(this).attr("data-banner");

                if (BackgroundBanner != null && BackgroundBanner != "" && BackgroundBanner != undefined) {
                    $(this).css("background", "url(" + BackgroundBanner + ")");
                    $(this).find("a:first").css("background", "none");
                }
            });
            //$('html, body').animate({ scrollTop: 0 }, 'slow');
            $("body").addClass("BackDropped LeftMenuOpen");

        }
        else {

            $("body").removeClass("BackDropped LeftMenuOpen");

        }

    });

    $(".close-img").live("click", function () {
        $("body").removeClass("BackDropped");
        $("#MainMenu").removeClass("open");
    });

    $('.SearchModal form input').keyup(function (event) {

        if (event.keyCode == 27) {

            $("body").removeClass("BackDropped");
            $(".SearchModal").hide();

        }
    });

    $('.CloseSearch').click(function (event) {


        $("body").removeClass("BackDropped");
        $(".SearchModal").hide();

    });

    if ($("#FbConfirmMergeModal").length > 0) {
        $("#FbConfirmMergeModal").modal("show");
    }

    if ($("#FbMergeResultModal").length > 0) {
        $("#FbMergeResultModal").modal("show");
    }

    if (window.location.hash == "#Rg" && isMobile(true)) {
        $('html, body').animate({
            scrollTop: $("#LineRg").offset().top + -80
        }, 500);
    }

    if (window.location.hash != undefined && document.URL.indexOf("Yardim") > 0) {
        var curHash = window.location.hash.replace("#", "");

        $("#helpMenu a[href$='" + curHash + "']").trigger("click");
    }

    if (window.location.hash == "#Lg" && isMobile(true)) {
        $('html, body').animate({
            scrollTop: $(".GeneralBreadCrumb:first").offset().top + -50
        }, 500);
    }

    $(".ForgetPass").on("click", function (e) {

        var forgottenPassModal = document.getElementById('forgottenpassModal');
        $('#forgottenpassModal').modal('show');
        forgottenPassModal.removeAttribute('aria-hidden');

    });

    $("#PayNow").on("click", function (e) {

        document.location.href = $(this).attr("href");

    });

    $(".ModalTab").on("click", function (e) {

        $(".ModalTab").removeClass("active");
        $(this).addClass("active");

        if ($(this).hasClass("Login")) {
            $(".LoginRow").show();
            $(".RegisterRow").hide();
        }
        else {

            $(".LoginRow").hide();
            $(".RegisterRow").show();
        }


    });

    //$("#AccountMenu a.LoginIcon, #AccountMenu a.RegisterIcon").live("click", function (e) {
    //    if ($("#LoginRegisterModal").length > 0) {
    //        $("#LoginRegisterModal").modal("show");

    //        if ($(this).hasClass("RegisterIcon") == true) {
    //            $(".ModalTab.Register").trigger("click");
    //        }
    //        else {
    //            $(".ModalTab.Login").trigger("click");
    //        }

    //        e.preventDefault();
    //        return false;
    //    }
    //});

    if ($("#WelcomeModal").length > 0) {
        $('#WelcomeModal').modal({
            // backdrop: "static"
        });
    }

    $("form.UyeOlModal").live("submit", function () {

        $(".UyeOlModal #Gsm").attr("disabled", false);// .serialize methodu 'disabled' attributune sahip nesneleri dahil etmediği için disabled attribute'ü silinir

        $form = $(this);

        $("#RegisterButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#RegisterButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("SignUp");
                    }

                    if (dt.JsonRs == "Redirect") {
                        if (dt.Deger5.length > 0) {
                            document.location = dt.Deger5;
                        }
                        else {
                            document.location = "/";
                        }
                    }
                    else if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = "/";
                    }

                    if (dt.JsonRs == "Reload") {
                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();
                        document.location.reload();
                    }


                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").addClass("alert-success").show().html(dt.IslemSonucAciklama);
                    $form.hide();
                    $("#AlertResult").parent().append("<a class='GenericLoginButton' id='start-shopping-button' href='/'>ALIŞVERİŞE BAŞLA</a>");
                }
                else {
                    ClearCloudflareWidgets();
                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().html(dt.IslemSonucAciklama);
                    $("html, body").animate({ scrollTop: 0 }, "slow");
                }

                DataLayerLoginSignUp("signup", dt.Deger8, dt.Field1, dt.Field2);
            },
            error: function () {
                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }
        });

        return false;
    });

    $("form.UyeGirisModal").live("submit", function () {
        var form = $(this);
        var userName = $('#UserName').val();

        var UserID = $("#UserID").val();

        if (UserID != "" && UserID > 0) {
            Isfollow();
        }

        $("#RegisterButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: form.attr("action"),
            data: form.serialize(),
            dataType: "json",
            success: function (dt) {
                $(".AjaxLoader").hide();
                $("#RegisterButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    //alert('giris buradan:' + 'username' + userName + 'userid' + UserID)
                    //window.dataLayer = window.dataLayer || [];
                    //dataLayer.push({
                    //    'event': 'login',
                    //    'email_permission': userName,
                    //    'sms_permission': '',
                    //    'userId': UserID //gönderilen değer, CRM panelindeki ‘üye id’ ile eşdeğer olmalıdır.
                    //});

                    $("#AlertResult").removeClass("alert-danger");

                    if (UseTagManager) {
                        AddUserAction("Login");
                    }

                    if (dt.JsonRs == "Reload") {
                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                        $(".AjaxLoader").show();
                        form.hide();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();
                    }
                    else if (dt.JsonRs == "Redirect") {
                        form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = dt.Deger5;
                    }

                    DataLayerLoginSignUp("login", dt.Deger8, dt.Field1, dt.Field2);

                }
                else {
                    ClearCloudflareWidgets();
                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger").show().find("span").html(dt.IslemSonucAciklama);
                }
            },
            error: function () {
                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }
        });

        return false;
    });

    // PRODUCTS HOVER 
    $(".ProductList .Prd a").live('click', function (e) {

        if (UseTagManager == true) {

            AddGaEvent('', 'Product List', 'Product Click', $(this).closest(".Prd"));

        }

        //return false;
        //e.preventDefault();


    });

    //if (isMobile(false) && isAppleMobile() && !IsAndroid()) {
    //    $(".ProductList .Prd").live('click', function (e) {
    //        document.location.href = $(this).find("a:first").attr("href");
    //    });
    //}

    var ScrollContentID = "LastScrollTop" + $("#PID").val();

    //if (isMobile(true) == false) {

    //    $(".ProductList .Prd").live({
    //        mouseenter:
    //        function () {
    //            $.cookie(ScrollContentID, null, { expires: -1 });
    //            $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });

    //            if (isMobile(false) && isAppleMobile() && !IsAndroid()) {
    //                document.location.href = $(this).find("a:first").attr("href");
    //            }

    //            $nextPrd = $(this).next();
    //            $prevPrd = $(this).prev();
    //            $curItem = $(this);
    //            $row = $curItem.parent();

    //            var index = $curItem.index();

    //            $topPrd = $(this).closest(".row").prev().find(".Prd:eq(" + index + ")");
    //            $bottomPrd = $(this).closest(".row").next().find(".Prd:eq(" + index + ")");

    //            if ($(this).find(".img2").length > 0 && $(this).find(".img2").attr("src") != undefined && $(this).find(".img2").attr("src") != "/images/src2.gif" && $(this).find(".img2").attr("src") != "") {

    //                $(this).find(".img1").hide();

    //                if ($(this).find(".img2").attr("data-src") != undefined && ($(this).find(".img2").attr("src") == undefined || $(this).find(".img2").attr("src").indexOf("404") != -1)) {
    //                    $(this).find(".img2").attr("src", $(this).find(".img2").attr("data-src"));
    //                }

    //                $(this).find(".img2").show();

    //            }

    //            if ($nextPrd.length > 0) {

    //                if ($nextPrd.find(".img2").length > 0 && $(this).find(".img2").attr("src") != undefined && $nextPrd.find(".img2").attr("src") != "/images/src2.gif" && $nextPrd.find(".img2").attr("src") != "") {

    //                    if ($nextPrd.find(".img2").attr("data-src") != undefined && ($nextPrd.find(".img2").attr("src") == undefined || $nextPrd.find(".img2").attr("src").indexOf("404") != -1)) {
    //                        $nextPrd.find(".img2").attr("src", $nextPrd.find(".img2").attr("data-src"));
    //                    }


    //                }
    //            }

    //            if ($prevPrd.length > 0) {

    //                if ($prevPrd.find(".img2").length > 0 && $prevPrd.find(".img2").attr("src") != "/images/src2.gif" && $prevPrd.find(".img2").attr("src") != "") {

    //                    if ($prevPrd.find(".img2").attr("data-src") != undefined && ($prevPrd.find(".img2").attr("src") == undefined || $prevPrd.find(".img2").attr("src").indexOf("404") != -1)) {
    //                        $prevPrd.find(".img2").attr("src", $prevPrd.find(".img2").attr("data-src"));
    //                    }

    //                }

    //            }

    //            if ($topPrd.length > 0) {

    //                if ($topPrd.find(".img2").length > 0 && $topPrd.find(".img2").attr("src") != "/images/src2.gif" && $topPrd.find(".img2").attr("src") != "") {

    //                    if ($topPrd.find(".img2").attr("data-src") != undefined && ($topPrd.find(".img2").attr("src") == undefined || $topPrd.find(".img2").attr("src").indexOf("404") != -1)) {
    //                        $topPrd.find(".img2").attr("src", $topPrd.find(".img2").attr("data-src"));
    //                    }


    //                }
    //            }

    //            if ($bottomPrd.length > 0) {

    //                if ($bottomPrd.find(".img2").length > 0 && $bottomPrd.find(".img2").attr("src") != "/images/src2.gif" && $bottomPrd.find(".img2").attr("src") != "") {

    //                    if ($bottomPrd.find(".img2").attr("data-src") != undefined && ($bottomPrd.find(".img2").attr("src") == undefined || $bottomPrd.find(".img2").attr("src").indexOf("404") != -1)) {
    //                        $bottomPrd.find(".img2").attr("src", $bottomPrd.find(".img2").attr("data-src"));
    //                    }

    //                }

    //            }

    //        },
    //        mouseleave:
    //        function () {

    //            if ($(this).find(".img2").length > 0 && $(this).find(".img2").attr("src") != "/images/src2.gif" && $(this).find(".img2").attr("src") != "") {

    //                $(this).find(".img2").hide();
    //                $(this).find(".img1").show();
    //            }

    //        }
    //    });
    //}

    $('.ProductList .Prd').live("click", function (e) {

        $.cookie(ScrollContentID, null, { expires: -1 });
        $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });

    });

    $('.ProductListColorContainer div.ProductListColor:not(.passive)').live("click", function () {

        var $currentColor = $(this);

        $(".AjaxLoader").show();

        var productID = $(this).attr("data-color-product-id");
        var colorID = $(this).attr("data-color");
        var item_unique_id = $(this).attr("data-item-unique-id");
        var params = "language=" + $("#SmallLangCode").val() + "&ColorID=" + colorID + "&ProductID=" + productID;

        $detailLinks = $(this).closest(".Prd").find("a");

        $currentColor.closest(".ProductListColorContainer").find(".ProductListColor").removeClass("active");

        $currentColor.addClass("active");

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetImageOfColors",
            data: params,
            success: function (data) {

                $(".AjaxLoader").hide();

                $Crs = $("#Crs_" + item_unique_id);

                $Crs.find("div.carousel-inner").html("");
                $Crs.find("ol.carousel-indicators").html("");
                var urlNew = "/";
                //kategori sayfasında ürün resime tıklandığında gidecek urli ayarlama.
                if (data.ProductUrl != undefined && data.ColorUrl != undefined) {
                    //urlNew += $("#SmallLangCode").val() + "/" + data.ColorName + "-" + data.ProductUrl + data.ColorUrl;
                    urlNew += $("#SmallLangCode").val() + "/" + data.ProductUrl;
                }
                var sizeQuery = "_614x805";

                var p_card_img_wr = "";
                var indicators_li = "";
                var i = 0;

                if (data.ImgPath1 != null) {
                    var $imgKucuk1 = $('<div class="active item"><a href="' + urlNew + '" ><img class="img1 PImage img-responsive" alt="" src="' + data.ImgPath1.replace("_buyuk", sizeQuery) + '" ></a></div>');
                    $imgKucuk1.appendTo($Crs.find("div.carousel-inner"));

                    p_card_img_wr += '<a href="' + urlNew + '" title="' + data.ProductName + '" data-id="Crs_' + item_unique_id + '" data-num="' + i + '" class="p-card-img-wr"></a>';

                    indicators_li += '<li data-target="#Crs_' + item_unique_id + '" data-slide-to="' + i + '" class="active"></li>'

                    i++;
                }
                if (data.ImgPath2 != null) {
                    var $imgKucuk2 = $('<div class="item"><a href="' + urlNew + '" ><img class="img2 PImage img-responsive" alt="" src="' + data.ImgPath2.replace("_buyuk", sizeQuery) + '" ></a></div>');
                    $imgKucuk2.appendTo($Crs.find("div.carousel-inner"));

                    p_card_img_wr += '<a href="' + urlNew + '" title="' + data.ProductName + '" data-id="Crs_' + item_unique_id + '" data-num="' + i + '" class="p-card-img-wr"></a>';

                    indicators_li += '<li data-target="#Crs_' + item_unique_id + '" data-slide-to="' + i + '" class=""></li>'

                    i++;
                }
                if (data.ImgPath3 != null) {
                    var $imgKucuk3 = $('<div class="item"><a href="' + urlNew + '" ><img class="img3 PImage img-responsive" alt="" src="' + data.ImgPath3.replace("_buyuk", sizeQuery) + '" ></a></div>');
                    $imgKucuk3.appendTo($Crs.find("div.carousel-inner"));

                    p_card_img_wr += '<a href="' + urlNew + '" title="' + data.ProductName + '" data-id="Crs_' + item_unique_id + '" data-num="' + i + '" class="p-card-img-wr"></a>';

                    indicators_li += '<li data-target="#Crs_' + item_unique_id + '" data-slide-to="' + i + '" class=""></li>'

                    i++;
                }
                if (data.ImgPath4 != null) {
                    var $imgKucuk4 = $('<div class="item"><a href="' + urlNew + '" ><img class="img4 PImage img-responsive" alt="" src="' + data.ImgPath4.replace("_buyuk", sizeQuery) + '" ></a></div>');
                    $imgKucuk4.appendTo($Crs.find("div.carousel-inner"));

                    p_card_img_wr += '<a href="' + urlNew + '" title="' + data.ProductName + '" data-id="Crs_' + item_unique_id + '" data-num="' + i + '" class="p-card-img-wr"></a>';

                    indicators_li += '<li data-target="#Crs_' + item_unique_id + '" data-slide-to="' + i + '" class=""></li>'

                    i++;
                }

                if (data.ImgPath5 != null) {
                    var $imgKucuk5 = $('<div class="item"><a href="' + urlNew + '" ><img class="img4 PImage img-responsive" alt="" src="' + data.ImgPath5.replace("_buyuk", sizeQuery) + '" ></a></div>');
                    $imgKucuk5.appendTo($Crs.find("div.carousel-inner"));

                    p_card_img_wr += '<a href="' + urlNew + '" title="' + data.ProductName + '" data-id="Crs_' + item_unique_id + '" data-num="' + i + '" class="p-card-img-wr"></a>';

                    indicators_li += '<li data-target="#Crs_' + item_unique_id + '" data-slide-to="' + i + '" class=""></li>'

                    i++;
                }

                $Crs.find("ol.carousel-indicators").html(indicators_li);

                $("#Crs_" + item_unique_id + "~ .product-card-grid-layout").html("");

                $("#Crs_" + item_unique_id + "~ .product-card-grid-layout").css('grid-template-columns', 'repeat(' + i + ', 1fr)')

                $("#Crs_" + item_unique_id + "~ .product-card-grid-layout").html(p_card_img_wr);


                //AddToCart attributeleri değiştir
                $currentColor.closest(".Prd").find(".AddToCart").attr("data-colorid", data.ColorID);
                $currentColor.closest(".Prd").find(".AddToCart").attr("data-productid", data.ProductID);
                $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", data.SizeID);

                $currentColor.closest(".Prd").find(".ProductBadge").html("");

                //sistemde tanımlı badgeler varsa eklenmeli.
                if (data.BadgeImagePath != null && data.BadgeImagePath != undefined && data.BadgeTur != 14) {

                    if (data.BadgeTur == 7) {

                        $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');

                    } else if (data.BadgeTur == 8) {

                        $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');


                    } else if (data.BadgeTur == 9) {

                        $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');


                    } else if (data.BadgeTur == 10) {

                        $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');

                    }
                }

                //alert("Amount:" + data.Amount);
                //alert("Amount:" + data.AmountOld);

                const AmountOldN2 = data.AmountOld.toLocaleString('tr-TR');
                const AmountN2 = data.Amount.toLocaleString('tr-TR');

                if (data.Amount !== null && data.Amount !== undefined && data.Amount !== "" && typeof (data.Amount) !== undefined) {
                    $currentColor.closest(".Prd").find(".PriceArea").find(".PPrice").text(data.CurrencySymbol + AmountN2);
                }

                if (data.AmountOld !== null && data.AmountOld !== undefined && data.AmountOld !== "" && typeof (data.AmountOld) !== undefined) {
                    $currentColor.closest(".Prd").find(".PriceArea").find(".PPOldPrice").text(data.CurrencySymbol + AmountOldN2);
                }

                if (data.DiscountRate !== null && data.DiscountRate !== undefined && data.DiscountRate !== "" && typeof (data.DiscountRate) !== undefined && data.DiscountRate == 0) {
                    $currentColor.closest(".Prd").find(".PriceArea").html("");

                    $currentColor.closest(".Prd").find(".PriceArea").prepend("<span class='PPrice'>" + (data.CurrencySymbol + AmountN2) + "</span>");
                }

                else if (data.DiscountRate !== null && data.DiscountRate !== undefined && data.DiscountRate !== "" && typeof (data.DiscountRate) !== undefined && data.DiscountRate > 0) {
                    $currentColor.closest(".Prd").find(".PriceArea").html("");

                    $currentColor.closest(".Prd").find(".PriceArea").prepend("<span class='PPrice DiscountedAmount'>" + (data.CurrencySymbol + AmountN2) + "</span>");
                    $currentColor.closest(".Prd").find(".PriceArea").prepend("<span class='PPrice PPOldPrice'>" + (data.CurrencySymbol + AmountOldN2) + "</span>");
                }

                if (data.productDetailPageCampaignModel != null) {
                    $currentColor.closest(".Prd").find(".PriceArea").append("<div class='basket-area'><span class='basket-text'>Sepette</span><span class='basket-amount'>" + (data.CurrencySymbol + data.productDetailPageCampaignModel.CampaignAmount) + "</span></div>");
                }

                //if (data.Amount < data.AmountOld) {
                //    if ($("#SmallLangCode").val() === "tr") {
                //        $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding freeShipping'><img src='/images/JMK/badge/kargo.png'></div>");
                //    }
                //}

                //if (data.DiscountRate !== null && data.DiscountRate !== undefined && data.DiscountRate !== "" && typeof (data.DiscountRate) !== undefined && data.DiscountRate > 0) {
                //     $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><span class='discount'>" + data.DiscountRate + "%</span><img src='/images/JMK/badge/indirim_bagde.png'></div>");
                //}

                if (data.TotalQuantity <= 0) {
                    $currentColor.closest(".Prd").find(".AddToCart").addClass("passive");
                    $currentColor.closest(".Prd").find(".AddToCart").attr('disabled', 'disabled');

                }
                else {
                    $currentColor.closest(".Prd").find(".AddToCart").removeClass("passive").removeAttr("disabled");
                }

                if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                    var swparams = GetSwPageParams();

                    swparams = ChangeSwHashedStringParamValue(swparams, "ActionType", "UrunRenkDegistirme");

                    swparams = ChangeSwHashedStringParamValue(swparams, "ProductID", productID);
                    swparams = ChangeSwHashedStringParamValue(swparams, "ColorID", colorID);

                    AddSwAction(swparams);

                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });

        //size divini yenilesin

        $currentColor.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").remove();




    });

    $('.ProductListSizeContainer div.ProductListSize:not(.passive)').live("click", function () {

        var $currentColor = $(this);

        $(".AjaxLoader").show();

        var productID = $(this).attr("data-color-product-id");
        var colorID = $(this).attr("data-color");
        var sizeID = $(this).attr("data-size");

        $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", sizeID);
        $currentColor.closest(".ProductListSizeContainer").find(".ProductListSize").removeClass("active");

        $currentColor.addClass("active");

        $currentColor.closest(".Prd").find(".AddToCart").click(); //sepet eklesin hemen
        $(".AjaxLoader").hide();
    });

    AddToCartAreaWidthSet();

    //SEPETE EKLE
    //$(".ProductList .Prd .AddToCartArea button.AddToCart").click(function (e) {
    $(document).on('click', '.ProductList .Prd .AddToCartArea button.AddToCart', function (e) {

        $basketButton = $(this);

        var SizeID = $basketButton.attr("data-sizeid");
        var ColorID = $basketButton.attr("data-colorid");
        var ProductID = $basketButton.attr("data-productid");
        var ProductCode = $basketButton.attr("data-productcode");
        var ProductName = $basketButton.attr('data-productname');
        var ProductOldAmount = $basketButton.attr('data-Old-Amount');
        var ProductAmount = $basketButton.attr('data-amount');
        var Discount = $basketButton.attr('data-discount');
        var brandName = $basketButton.attr('data-brandname');
        var colorName = $basketButton.attr('data-colorName');
        var CatID = $basketButton.attr('data-CatID');
        var itemListName = $basketButton.attr('data-itemListName');

        var category1 = $basketButton.attr('data-category1');
        var category2 = $basketButton.attr('data-category2');
        var category3 = $basketButton.attr('data-category3');


        var LangID = $("#SmallLangCode").val();
        var Amount = "1";

        if (ProductAmount == ProductOldAmount) {
            ProductAmount = 0;
        }


        var amount = ProductAmount;

        if (amount == 0) {
            amount = ProductOldAmount;
        }

        var value = parseFloat(amount);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "" && SizeID != "0" && ColorID != "0" && ProductID != "0") {

            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    var storedCatalog = localStorage.getItem('selectedCatalog');
                    var storedCatalogID = localStorage.getItem('selectedCatalogID');                    

                    window.dataLayer = window.test || [];
                    if (window.dataLayer) {
                        try {
                            dataLayer.push({
                                'event': 'add_to_cart',

                                'ecommerce': {
                                    'currency': 'TRY',
                                    'value': value, // Number olacak. price * quantity olacak. Sadece küsüratta nokta olacak.
                                    'items': [{
                                        'item_name': ProductName,
                                        'item_id': ProductCode,
                                        'affiliation': category1,
                                        'coupon': '',
                                        'currency': 'TRY',
                                        'discount': parseInt(Discount),
                                        'index': 0,
                                        'item_brand': "JMK",
                                        'item_category': category1, // Kaç tane category varsa sırayla eklenecek. Yoksa "" boş gidebilir.
                                        'item_category2': category2,
                                        'item_category3': category3,
                                        'item_list_id': parseInt(storedCatalogID),
                                        'item_list_name': storedCatalog,
                                        'item_variant': colorName,
                                        'location_id': 'İZ',
                                        'price': parseFloat(ProductOldAmount), // Number olacak.
                                        'quantity': 1, // Number olacak.
                                    }]
                                }
                            });
                        } catch (e) {

                        }
                    }



                    //end datalayuer

                    if ($(window).width() < 768) {
                        $basketButton.html("<div class='BasketIcon hidden-md hidden-lg'></div>" + NormalText);
                    }
                    else {
                        $basketButton.text(NormalText);
                    }

                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {
                        $Modal = $("div#QuickLookModal");

                        if ($Modal.length > 0) {
                            $Modal.modal("hide");
                        }

                        if (dt.Deger8 !== null && dt.Deger8 !== undefined && dt.Deger8 !== '') {

                            var _customModels = dt.Deger8.split("<InsiderObjectBeginning>");

                            if (_customModels !== null) {

                                //#region Related Datalayer Add To Basket Operation
                                if (window.dataLayer !== null && window.dataLayer !== undefined) {
                                    var _dataLayerObject = _customModels[0];

                                    if (_dataLayerObject !== null && _dataLayerObject !== undefined && _dataLayerObject !== '') {
                                        window.dataLayer.push(JSON.parse(_dataLayerObject));
                                    }
                                }
                                //#endregion

                                //#region Insider Object Add To Basket Operation
                                //if (window.insider_object !== null && window.insider_object !== undefined) {
                                //    var _insiderObject = _customModels[1];

                                //    if (_insiderObject !== null && _insiderObject !== undefined && _insiderObject !== '') {
                                //        window.insider_object = JSON.parse(_insiderObject);
                                //    }
                                //}
                                updateInsiderObjectIfChanged(_customModels[1]);
                                //#endregion
                            }
                        }

                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {

                                $("#UserMenus  #UserAndBasket").html(dt);

                                //$('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BackDropped");

                                $(".SepetProducts").hide();
                                $(".SepetButton a").trigger("click");
                                //setBasketContainerHeight();
                                setContentHeight();
                                $(".AjaxLoader").hide();

                                $basketButton.closest("div.AddToCartArea").find("button.AddToCart").attr("data-sizeid", "0");
                                $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").remove();
                            }
                        });

                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);
                        }

                        if (UseTagManager) {
                            SendCartAddEvent('');
                        }
                    }
                    else {
                        alert(dt.IslemSonucAciklama);
                    }
                }
            });
        }
        else if (SizeID === "0" && $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").length === 0) {

            var params = "ColorID=" + ColorID + "&ProductID=" + ProductID;

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetSizeOfColors",
                data: params,
                success: function (data) {

                    $(".AjaxLoader").hide();

                    $basketButton.closest("div.AddToCartArea").find("button.AddToCart").before(data);

                    var $firstSize = $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize.active:first");

                    var firstSizeId = ($firstSize.length > 0 ? $firstSize.attr("data-size") : 0);

                    $basketButton.removeClass("passive");

                    if (firstSizeId === 0) {
                        $basketButton.addClass("passive");

                        //if ($("#SmallLangCode").val() === "tr") {
                        //    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><img src='/images/JMK/badge/tukendi.png'></div>");

                        //}
                        //else if ($("#SmallLangCode").val() === "en") {
                        //    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><img src='/images/JMK/badge/sold_out.png'></div>");
                        //}
                        //else if ($("#SmallLangCode").val() === "fr") {
                        //    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><img src='/images/JMK/badge/epuise.png'></div>");
                        //}
                    }

                    //***** ilk size id default seçili gelmesin dediler. o yüzden AddToCarta sizeid yazmasın ve size kutularındaki active kaldırılıyor. 
                    //size kutularına ilk başta active classı eklememizin sebebi yukarıda tukendi badge çıkartabilmek için
                    //$basketButton.attr("data-sizeid", firstSizeId);
                    $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize").removeClass("active");
                },
                error: function () {

                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                }

            });
        }

        e.preventDefault();
        return false;

    });

    if ($(".ContentPgArea").length > 0 && isMobile(true)) {
        $('html, body').animate({ scrollTop: $(".ContentPgArea").offset().top }, 'slow');
    }

    $("body").on("submit", "form.ForgettenForm", function () {

        $(".AjaxLoader").show();
        $form = $("form.ForgettenForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {
                $(".AjaxLoader").hide();
                if (dta.Sonuc == true) {
                    if (dta.Deger9 != null) {
                        if (dta.Deger9 == "email") {
                            $("#forgottenpassModal .modal-dialog .modal-content").html(dta.IslemSonucAciklama);
                        }
                        else if (dta.Deger9 == "gsm") {
                            var confirmGsmModal = document.getElementById('confirmGsmModal');
                            var forgottenPassModal = document.getElementById('forgottenpassModal');

                            // İlk modalı gizle ve erişilemez yap
                            $(forgottenPassModal).modal('hide');
                            forgottenPassModal.setAttribute('aria-hidden', 'true');
                            forgottenPassModal.setAttribute('inert', '');

                            // İkinci modalı erişilebilir yap ve aç
                            confirmGsmModal.removeAttribute('aria-hidden');
                            confirmGsmModal.removeAttribute('inert');
                            $(confirmGsmModal).modal('show');

                            // İkinci modalda input alanına odaklan
                            confirmGsmModal.querySelector('input[name="verificationCode"]').focus();

                            // İkinci modal kapandığında, ilk modalı tekrar erişilebilir yap
                            $('#confirmGsmModal').on('hidden.bs.modal', function () {
                                forgottenPassModal.removeAttribute('aria-hidden');
                                forgottenPassModal.removeAttribute('inert');
                                forgottenPassModal.querySelector('.close').focus();
                            });
                        }
                    }

                }
                else {

                    $(".ForgettenForm .AlertResult").html(dta.IslemSonucAciklama);
                    $(".ForgettenForm .AlertResult").addClass("alert alert-error");
                }

            },
            error: function () {
                $(".AjaxLoader").hide();
                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });

        return false;

    });

    $("body").on("submit", "form.ConfirmSMSForm", function (e) {
        e.preventDefault();

        $(".AjaxLoader").show();
        var $form = $(this);

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {
                $(".AjaxLoader").hide();

                if (dta.Sonuc === true) {
                    $(".ConfirmSMSForm .AlertResult")
                        .html(dta.IslemSonucAciklama)
                        .removeClass("alert-danger")
                        .addClass("alert alert-success");

                    setTimeout(function () {
                        if (dta.Deger5) {
                            window.location.href = dta.Deger5;
                        }
                    }, 1000);
                } else {
                    $(".ConfirmSMSForm .AlertResult")
                        .html(dta.IslemSonucAciklama)
                        .removeClass("alert-success")
                        .addClass("alert alert-danger");
                }
            },
            error: function () {
                $(".AjaxLoader").hide();
                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.');
            }
        });
    });

    $('#confirmGsmModal').on('hidden.bs.modal', function () {
        var forgottenPassModal = document.getElementById('forgottenpassModal');
        forgottenPassModal.removeAttribute('aria-hidden');
        forgottenPassModal.removeAttribute('inert');
        forgottenPassModal.querySelector('.close').focus();
    });

    $("form.UyeOl").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();
        $(".Header1, .Header2").hide();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#RegisterButton").removeAttr("disabled");


                if (dt.Sonuc == true) {

                    if (dt.JsonRs == "Redirect") {
                        if (dt.Deger5.length > 0) {
                            document.location = dt.Deger5;
                        }
                        else {
                            document.location = "/";
                        }
                    }

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").hide();

                    //$("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                    $form.hide();
                }
                else {
                    ClearCloudflareWidgets();

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    var utm_source = getQuery(window.location.href).utm_source;
    var utm_campaign = getQuery(window.location.href).utm_campaign;
    var utm_medium = getQuery(window.location.href).utm_medium;

    if ((utm_source != undefined && utm_source.length > 0) || (utm_campaign != undefined && utm_campaign.length > 0) || (utm_medium != undefined && utm_medium.length > 0)) {
        $.ajax({
            url: "/" + $("#SmallLangCode").val() + "/p/User/SetUtmParam",
            data: "utm_source=" + utm_source + "&utm_campaign=" + utm_campaign + "&utm_medium=" + utm_medium,
            type: "POST",
            cache: false
        });
    }

    $("#SwitchNewLayout").live("click", function () {

        changeSiteTheme($(this).attr("data-ly"));

    });

    if ($(window).width() < 993) {

        $("header .SepetRow").hammer().on("swiperight", function (e) {

            $(this).find(".RemoveIcon").trigger("click");

            e.stopPropagation();
            e.preventDefault();
        });

        $("header .SepetRow").hammer().on("swipeleft", function (e) {

            $(this).find(".RemoveIcon").trigger("click");

            e.stopPropagation();
            e.preventDefault();
        });

    }

    $("#SingOut").live("click", function (e) {

        if (UseTagManager) {
            AddUserAction("Signout");
        }
        //e.preventDefault();
        //return false;

    });

    if (1 == 2 && $("#homebannerFull1").length > 0 && !isMobile(true)) {

        $(document).snowfall('clear');
        $(document).snowfall({ shadow: true, round: true, minSize: 1, maxSize: 5, flakeCount: 200 }); // add shadows

    }


    if ($(window).width() > 1000) {


        $("#LoginRegisterModal .Login").live("click", function (e) {
            $('#LoginRegisterModal .modal-content').css();
        });

        $("#LoginRegisterModal .Register").live("click", function (e) {
            $('#LoginRegisterModal .modal-content').css();
        });

    }

    window.onpageshow = function (event) {
        if (event.persisted) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                data: "",
                async: true,
                cache: false,
                contentType: "application/json; charset=utf-8",
                dataType: 'text',
                success: function (dt) {
                    $("#UserAndBasket").html(dt);
                    TagAutoComplate();

                    if ($("#LangRedirectNeed").length > 0) {
                        //  changeSiteLanguage("0", $("#LangRedirectNeed").val());
                    }

                    if ($("#LangSelectionNeed").length > 0) {
                        ShowLangAreaForChange();
                    }

                    var UserID = $("#UserID").val();

                    if (UserID != undefined && UserID > 0) {
                        Isfollow();
                    }

                    if (UseTagManager) {
                        AddGeneralInfoTagManager('', dtIsLogged, dtUserID);

                        AddProductView('');
                        var promotions = GetPromotionsVariable('');
                        AddImpression('', promotions);
                        //  AddGASliderView('');

                        SendGaDataLayerVirtual();
                    }
                }
            });
        }
    };

    $("#Gsm").mask("999 999 99 99", {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });
    if ($("#Gsm").length > 0) {
        $(document).on("keyup", "#Gsm", function () {
            var phone = $(this).val();
            var firstChar = phone.substr(0, 1);

            if (firstChar != "5" && phone.length > 1) {
                $(this).val("");
            }
            else if (firstChar != "5") {
                phone = phone.substr(1, phone.length);
                $(this).val(phone);
            }
        });
    }

    $(".SepetButton.newMiniBasket a").live("click", function () {
        $(".CartPrice .AjaxLoader").show();

        $.ajax({
            type: 'get',
            url: '/Cart/GetMiniBasketExtraDetails',
            success: function (data) {

                $(".CartPrice .AjaxLoader").hide();

                $(".CartPrice").html(data);

            },
            error: function () {
            }
        });
    });


    //#region LOGIN & REGISTER
    var UseTagManager = false;


    $("body.CheckOut").on("click", "a.RegisterIcon, a.LoginIcon, #CheckoutHeader .RegisterIcon a, #CheckoutHeader  .LoginIcon a, #CheckoutHeader  a.RegisterIcon , #CheckoutHeader  a.LoginIcon", function (e) {

        $("#LoginRegisterModal").modal('show');

        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

            var swparams = GetSwPageParams();
            swparams = ChangeSwHashedStringParamValue(swparams, "ActionType", "SiparisUyelikPopupAcma");
            AddSwAction(swparams);

        }

        if (UseTagManager) {
            AddCheckOutView('', 2);
            SendGaDataLayerVirtual();
        }

        e.preventDefault();
        return false;
    });

    $("body").on("click", "#ReadPreInformation", function (e) {
        $("#PreInformationContent").html($("#OnBilgilendirmetails").html());
        $("#PreInformationModal").modal('show');
        return false;
    });

    $("body").on("click", "#ReadAgreementDetails", function (e) {
        $("#AgreementDetailsContent").html($("#AgreementDetails .mag_container.section1").html());
        $("#AgreementDetailsModal").modal('show');
        return false;
    });


    $("body").on("click", ".ForgetPass", function (e) {
        var forgottenPassModal = document.getElementById('forgottenpassModal');
        $('#forgottenpassModal').modal('show');
        forgottenPassModal.removeAttribute('aria-hidden');

    });

    $("body").on("change", ".adrestipradio", function () {

        if ($("#AdresTipi2").is(":checked")) {
            $(".vergi").show("slow");
            $(".bireyselFatura").hide("slow");

        }
        else {
            $(".vergi").hide("slow");
            $(".bireyselFatura").show("slow");

        }

        //if ($("#AdresTipi3").is(":checked")) {
        //    $(".bireyselFatura").show("slow");
        //} else {
        //    $(".bireyselFatura").hide("slow");

        //}

    });

    $("#TcNo").mask("99999999999", {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });

    $("#Gsm,#PhoneNumber").mask("999 999 99 99", {
        translation: {
            'Z': {
                pattern: /[0-9]/, optional: true
            }
        }
    });


    if ($("#Gsm,#PhoneNumber").length > 0) {
        $(document).on("keyup", "#Gsm,#PhoneNumber", function () {
            var phone = $(this).val();
            var firstChar = phone.substr(0, 1);

            if (firstChar != "5" && phone.length > 1) {
                $(this).val("");
            }
            else if (firstChar != "5") {
                phone = phone.substr(1, phone.length);
                $(this).val(phone);
            }
        });
    }
    // Özel karakter kısıtı
    //$("#OrderNoteText").keydown(function (e) {
    //    var test = /^[a-zA-ZğüşöçİĞÜŞÖÇ0-9.,;'":/\-*&!?$@%()\[\]<>+~#_ ]+$/; //regex
    //    var value = String.fromCharCode(e.keyCode); //get the charcode and convert to char
    //    if (!value.match(test)) {
    //        return false; //dont display key if it is a number
    //    }
    //});

    $("#OrderGiftNoteText").keydown(function (e) {
        var test = [A - Za - z0 - 9]; //regex
        var value = String.fromCharCode(e.keyCode); //get the charcode and convert to char

        if (!value.match(test)) {
            return false; //dont display key if it is a number
        }
    });

    //#region JKMoneyPuan Functions
    $(document).on("submit", ".SummaryContainer #JKMoneyPuanForm", function () {
        var JKMoneyPuanAmount = $(this).find("#JKMoneyPuanInput").val();
        UseJKMoneyPuan(JKMoneyPuanAmount); // 'false' ile Como kuponu olmadığı belirtilmiş oluyor

        return false;
    });

    $(document).on("click", "#OrderSummary .OrderJKMoneyPuan.UsedJKMoneyPuan button#RemoveJKMoneyPuan", function () {
        RemoveJKMoneyPuan();
    });

    // JKMoneyPuan silme
    $("body").on("click", "#RemoveJKMoneyPuan", function (e) {
        RemoveJKMoneyPuan();
        e.preventDefault();

        return false;
    });
    //#endregion END JKMoneyPuan Functions



    //region Begin : Checkout Login and Register

    // Checkout Login : Begin
    $(document).on("click", "#LoginRegisterModal .UyeGirisModal #LoginButton", function () {

        var form = $("#LoginRegisterModal .UyeGirisModal");
        $("#LoginRegisterModal .UyeGirisModal #Gsm").attr("disabled", false);// .serialize methodu 'disabled' attributune sahip nesneleri dahil etmediği için disabled attribute'ü silinir

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: form.attr("action"),
            data: form.serialize() + "&reload=true",
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("Signup");
                    }

                    if (dt.JsonRs == "Redirect") {

                        form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = "/";
                    }

                    if (dt.JsonRs == "Reload") {

                        form.hide();

                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();
                    }
                    clearAndHidErrorAlertResult()
                }
                else {
                    ClearCloudflareWidgets();
                    showErrorAlertResult(dt.IslemSonucAciklama);
                }
            },
            error: function (ex) {
                console.log(JSON.stringify(ex));
                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!' + ex);
            }

        });


        return false;
    });
    // Checkout Login : End

    // Checkout Register : Begin
    $(document).on("click", "#LoginRegisterModal .UyeOlModal #RegisterButton", function () {
        RegisterSubmit();
    });
    // Checkout Register : End

    // Kullanıcı izinleri
    $(document).on("click", "#LoginRegisterModal .TermsCon label, #LoginRegisterModal .RememberCheck label", function () {
        var customCheckView = $(this).find(".customCheck");
        if (customCheckView.hasClass("checked")) {
            customCheckView.removeClass("checked");
        }
        else {
            customCheckView.addClass("checked");
        }
    });

    // giriş yöntemi değiştirme
    $('#LoginRegisterModal .login-type-container input[type=radio][name=IsGsmLogin]').change(function () {
        if (this.value == 'true') {
            $(".UyeGirisModal #PhoneNumber").removeClass("hidden");
            $(".UyeGirisModal #UserName").addClass("hidden");
        }
        else if (this.value == 'false') {
            $(".UyeGirisModal #UserName").removeClass("hidden");
            $(".UyeGirisModal #PhoneNumber").addClass("hidden");
        }
    });


    //#region  Begin :Sms Confirmation
    // Hata mesajını göster
    function showErrorAlertResult(message) {
        $("#LoginRegisterModal #AlertResult").html(message);
        $("#LoginRegisterModal #AlertResult").addClass("alert-danger");
        $("#LoginRegisterModal #AlertResult").show();
        $("html, body").animate({ scrollTop: 0 }, "slow");
    };
    // Hata div'in gizle ve teizle
    function clearAndHidErrorAlertResult() {
        $("#LoginRegisterModal #AlertResult").html("");
        $("#LoginRegisterModal #AlertResult").remove("alert-danger");
        $("#LoginRegisterModal #AlertResult").hide();
    }

    // Telefon numarasına onay kodu gönder
    $(document).on("click", "#LoginRegisterModal .UyeOlModal #sendConfirmationSmsCode", function (e) {
        RegisterFormConditionsCheck($(this).closest("form").serialize());

        //sendSmsConfirmationCode(e);
    });

    // Modal'ı kapat
    $("#smsConfirmationModalCheckOut #closeIcon").on("click", function () {
        $("#smsConfirmationModalCheckOut").hide()
    });

    // Onay kodu doğrulama
    $("#confirmSmsCodeBtn").on("click", function () {
        var confirmationCode = $("#smsConfirmationModalCheckOut #smsConfirmationCode").val();
        if (confirmationCode != undefined && confirmationCode.length == 6) {
            clearAndHidErrorAlertResult();
            $.ajax({
                type: 'POST',
                url: '/' + $("#SmallLangCode").val() + '/p/User/VerifySmsConfirmationCode?confirmationCode=' + confirmationCode,
                success: function (dt) {
                    if (dt.Sonuc) {

                        $("#LoginRegisterModal").show(); // Üye ol modalını tekrar aç

                        // Hata varsa temizle
                        $("#AlertResult").removeClass("alert-error");
                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").html("");
                        $("#AlertResult").hide();

                        // Onay kodu Modal'ı aç
                        $("#smsConfirmationModalCheckOut").hide();
                        $("#LoginRegisterModal .UyeOlModal .Buttons").html(dt.IslemSonucAciklama); // submit butonunu forma ekle
                        $("#AlertResult").html("Sms onaylama işlemi tamalanmıştır.");
                        //if (dt.Deger10 === "SkipSms") {
                        //    RegisterSubmit();
                        //    return;
                        //}
                        RegisterSubmit();
                        $("#AlertResult").addClass("alert-success");
                        $("#AlertResult").show();
                        $("html, body").animate({ scrollTop: 0 }, "slow");
                        $(".UyeOl #Gsm").attr("disabled", "disabled"); // numarayı değiştireyi kapat
                        $(".g-recaptcha").remove();
                    }
                    else {
                        $("#AlertResultConfModal").html(dt.IslemSonucAciklama)
                        $("#AlertResultConfModal").addClass("alert alert-danger");
                        $("#AlertResultConfModal").show();
                    }
                }
            });
        } else {
            $("#AlertResultConfModal").html("Lütfen 6 haneli onay kodunu giriniz!")
            $("#AlertResultConfModal").addClass("alert alert-danger");
            $("#AlertResultConfModal").show();
        }
    });

    //$("#smsConfirmationCode").on("click", function () {
    //    $("#smsConfirmationCode")[0].focus();
    //})

    //#endregion End : Sms Confirmation

    //#endregion End : Checkout Login and Register

    function RegisterSubmit() {
        var form = $("#LoginRegisterModal .UyeOlModal");
        $("#LoginRegisterModal .UyeOlModal #Gsm").attr("disabled", false);// .serialize methodu 'disabled' attributune sahip 

        $("#RegisterButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: form.attr("action"),
            data: form.serialize() + "&reload=true",
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#RegisterButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("Signup");
                    }
                    if (dt.JsonRs == "Redirect") {
                        form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = "/";
                    }

                    if (dt.JsonRs == "Reload") {

                        form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();
                        document.location.reload();
                    }
                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").hide();
                    //$("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);
                }
                else {
                    ClearCloudflareWidgets();
                    $("#LoginRegisterModal").show();
                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-error").show().html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }
        });
    }

    // Tekrar Sms Gönder
    $(document).on("click", "#smsConfirmationModalCheckOut #retryConfirmationBtn", function (e) {
        $("#smsConfirmationModalCheckOut #retryConfirmationBtn").addClass("hidden");
        sendSmsConfirmationCode(e);
        SendSmsCountDown();
    });

    $(document).on("click", "#testTimer", function (e) {
        SendSmsCountDown();
    });

    $(document).on("click", ".GenderCon label", function () {
        $(".GenderCon label .customCheck").removeClass("checked");

        // Seçilen öğeye "checked" sınıfını ekle
        var customCheckView = $(this).find(".customCheck");
        customCheckView.addClass("checked");
    });

    $(document).on("click", ".KvkkCon label", function () {

        var customCheckView = $(this).find(".customCheck");
        if (customCheckView.hasClass("checked")) {
            customCheckView.removeClass("checked");
        }
        else {
            customCheckView.addClass("checked");
        }
    });

    $(document).on("click", ".RegisterTermsCon label", function () {

        var customCheckView = $(this).find(".customCheck");
        if (customCheckView.hasClass("checked")) {
            customCheckView.removeClass("checked");
        }
        else {
            customCheckView.addClass("checked");
        }
    });

    function SendSmsCountDown() {
        var treeMinutes = 60 * 3;
        startTimer(treeMinutes)
    }

    function startTimer(duration) {
        var timer = duration, minutes, seconds;
        var interval = setInterval(function () {
            minutes = parseInt(timer / 60, 10)
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            $("#timerText").html(minutes + ":" + seconds);

            if (--timer < 0) {
                $("#smsConfirmationModalCheckOut #timerText").html("");
                $("#smsConfirmationModalCheckOut #retryConfirmationBtn").removeClass("hidden");
                clearInterval(interval);
            }
        }, 1000);
    }

    function RegisterFormConditionsCheck(data) {
        $(".AjaxLoader").show();
        $.ajax({
            type: 'POST',
            data: data,
            url: '/' + $("#SmallLangCode").val() + '/p/User/RegisterFormConditionsCheck',
            success: function (dt) {
                if (dt.Sonuc) {
                    sendSmsConfirmationCode(data);

                } else {
                    showErrorAlertResult(dt.Deger9);
                }
            }
        });

        $(".AjaxLoader").hide();
    }

    function toggleGlobal() {
        $("#UserAndBasket .RightGlobal > .langSwitchContainer").toggleClass("open");

        if ($("#UserAndBasket .RightGlobal > .langSwitchContainer").hasClass("open")) {
            $(".backdrop").addClass("active");
            $(".backdrop").addClass("globalDrop");
        } else {
            $(".backdrop").removeClass("active");
            $(".backdrop").removeClass("globalDrop");
        }
    }

    function sendSmsConfirmationCode(e) {
        var gsmNumber = $(".UyeOlModal #Gsm").val();
        if (gsmNumber != undefined && gsmNumber.length == 13) {
            clearAndHidErrorAlertResult();
            $(".AjaxLoader").show();

            var form = $(this).closest("form");
            var gRecaptchaResponse = $("input[name='cf-turnstile-response']").val();
            $.ajax({
                type: 'POST',
                url: '/' + $("#SmallLangCode").val() + '/p/User/SendConfirmationSms?gsm=' + gsmNumber + '&gc=' + gRecaptchaResponse,
                success: function (dt) {
                    if (dt.Sonuc) {
                        // Hata varsa temizle
                        $("#AlertResult").removeClass("alert-error");
                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").html("");
                        $("#AlertResult").hide();
                        if (dt.Deger10 === "SkipSms") {
                            RegisterSubmit();
                            return;
                        }
                        $("#LoginRegisterModal").hide();
                        // Onay kodu Modal'ı aç
                        $("#smsConfirmationModalCheckOut").show();
                        $("#smsConfirmationModalCheckOut .smsConfirmationInfoLabel").html("Lütfen " + gsmNumber + " numaralı telefona gelen SMS onay kodunu giriniz!");
                        $("#smsConfirmationModalCheckOut #lastSenderDate").val(dt.Deger5);
                        SendSmsCountDown();


                    } else {
                        showErrorAlertResult(dt.IslemSonucAciklama)
                    }
                }
            });
            $(".AjaxLoader").hide();
        } else {
            showErrorAlertResult("Lütfen telefon numaranızı istenilen formatta giriniz (999 999 99 99)")
        }
        e.preventDefault;
    }

    // ÜYE OL KAMPANYA VE DUYURU CHECKBOX
    // Açık Rıza onay butonunu seçin
    var acikRizaCheckbox = document.getElementById("AllowConsent");

    // İletişim kanalı butonlarını seçin
    var AllowMailCheckbox = document.getElementById("AllowMail");
    var AllowSmsCheckbox = document.getElementById("AllowSms");
    var AllowCallCheckbox = document.getElementById("AllowCall");
    var AllowWhatsappCheckbox = document.getElementById("AllowWhatsapp");

    if (acikRizaCheckbox) {
        // Açık Rıza onay butonuna tıklandığında
        acikRizaCheckbox.addEventListener("click", function () {
            if (acikRizaCheckbox.checked) {
                // Eğer Açık Rıza onayı işaretli ise, iletişim kanallarını işaretle
                AllowMailCheckbox.checked = true;
                AllowSmsCheckbox.checked = true;
                AllowCallCheckbox.checked = true;
                AllowWhatsappCheckbox.checked = true;

                $(".TermsCon label .customCheck").addClass("checked");

            } else {
                // Açık Rıza onayı işareti kaldırılırsa, iletişim kanallarını temizle
                AllowMailCheckbox.checked = false;
                AllowSmsCheckbox.checked = false;
                AllowCallCheckbox.checked = false;
                AllowWhatsappCheckbox.checked = false;

                $(".TermsCon label .customCheck").removeClass("checked");
            }
        });

        // İletişim kanalı butonlarına tıklandığında
        AllowMailCheckbox.addEventListener("click", updateAcikRiza);
        AllowSmsCheckbox.addEventListener("click", updateAcikRiza);
        AllowCallCheckbox.addEventListener("click", updateAcikRiza);
        AllowWhatsappCheckbox.addEventListener("click", updateAcikRiza);

        function updateAcikRiza() {
            if (AllowMailCheckbox.checked || AllowSmsCheckbox.checked || AllowCallCheckbox.checked || AllowWhatsappCheckbox.checked) {
                // Herhangi bir iletişim kanalı seçildiğinde Açık Rıza'yı işaretle
                acikRizaCheckbox.checked = true;
                $(".acikRizaCheckbox").addClass("checked");
            } else {
                // İletişim kanallarının tüm işaretleri kaldırılırsa Açık Rıza'yı temizle
                acikRizaCheckbox.checked = false;
                $(".acikRizaCheckbox").removeClass("checked");
            }
        }
    }

});

$(window).load(function () {

    // $(".UseLazyLoad").Lazy();

    $("#NewOpenSearch a").live("click", function () {

        var search = $("#search").val();

        if (search != undefined && search.length > 0) {
            window.location.href = "/" + $("#SmallLangCode").val() + "/p/Cat/NewSearch?sr=" + search;
        }
    });
});